(function(){
'use strict';

/* ============================================================
   WIRING · production constants
   ENDPOINT: the form's own Worker (audit-form pattern: POST upsert,
   GET ?action=get&email= for resume, POST /complete on submit).
   FACTORY_BEACON: fires type form_submit on completion.
   DEMO_MODE short-circuits all network into localStorage so the
   full engine is observable in this prototype.
   ============================================================ */
var ENDPOINT = 'https://script.google.com/macros/s/AKfycby5kOWIij4YN6TczXtp1oGDQPqpGhzS14FnUy1T6BZugwJl4ntilmZBllRWpOip5lyK/exec';
var FACTORY_BEACON = 'https://acquisition.arcticgrey.org/ingest/form-conversion';
var FORM_SECRET = 'agfc_dab52133339a647b670884399a4b5da5323fb69b'; /* same client-side secret the live page already ships */
var DEMO_MODE = false;
var FORM_VERSION = 'td-1.5';
var BOOT_TS = Date.now();
/* The fill clock anchors to the first page view of this submission and only
   ever moves EARLIER. BOOT_TS alone reset it on every reload, so a lead who
   resumed and submitted minutes later reported a seconds-long fill_ms and got
   stamped as a bot (Zendesk 1118239744: a 7m49s fill recorded as 2594ms). The
   anchor rides every draft and row as fill_start_ts; resume adopts it back. */
var fillStartTs = BOOT_TS;
function adoptFillStart(row){
  if(!row) return;
  var cands = [];
  var ts = Number(row.fill_start_ts);
  if(ts > 0) cands.push(ts);
  /* rows saved before the anchor existed still dated themselves: the save's own
     clock minus the fill it reported at that moment is when the fill began */
  var ct = Number(row.client_ts), fm = Number(row.fill_ms);
  if(ct > 0 && fm > 0 && fm < ct) cands.push(ct - fm);
  var ka = Date.parse(row.kickoff_at || '');
  if(ka > 0) cands.push(ka);
  for(var i = 0; i < cands.length; i++){
    if(cands[i] > 0 && cands[i] <= Date.now() && cands[i] < fillStartTs) fillStartTs = cands[i];
  }
}
var PREFERS_REDUCED = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);

/* ---------- dynamic form engine: one form, many entry points ----------
   The URL decides which form this is; the engine, autosave, resume, uploads,
   and every downstream wire stay shared. New entry points are configs. */
var FORM_TYPES = {
  'library': {
    source: 'form-library',
    topbar: 'Form library',
    steps: ['library'],
    chrome: false
  },
  'test-drive': {
    source: 'test-drive-form',
    topbar: 'Shopify Test Drive',
    label: 'Test Drive',
    steps: null
  },
  'contact': {
    source: 'contact-form',
    progressNote: 'Usually answered same day',
    contactHeadline: 'Last step. Who should we reply to?',
    topbar: 'Contact',
    label: 'Contact',
    steps: ['welcome', 'name', 'message', 'contact'],
    headline: 'Talk to Arctic Grey.',
    lede: 'Start with your email so the right person can reply, usually the same business day.',
    submitLabel: 'Send message',
    consentText: 'I agree to Arctic Grey contacting me about this message. No spam, no lists.',
  },
  'feedback': {
    source: 'feedback-form',
    progressNote: 'Read by leadership',
    contactHeadline: 'Last step. Where do we reply?',
    topbar: 'Feedback',
    label: 'Feedback',
    steps: ['welcome', 'name', 'feedbackContact', 'feedbackMood', 'feedbackScorecard', 'feedbackWords', 'message', 'contact'],
    headline: 'How can we serve you better?',
    lede: 'Start with your email so we know whose experience this is. Two minutes, straight to leadership.',
    submitLabel: 'Send my feedback',
    messageHeadline: 'Anything else?',
    messageLede: 'The thing we forgot to ask. It goes to the leadership team word for word.',
    consentText: 'I agree to Arctic Grey contacting me about this feedback. No spam, no lists.'
  },
  review: {
    source: 'review-form',
    progressNote: 'Public · only with your say-so',
    contactHeadline: 'Last step. Whose name signs the review?',
    topbar: 'Public review',
    label: 'Review',
    steps: ['welcome', 'name', 'storeUrl', 'feedbackContact', 'reviewRating', 'reviewWords', 'reviewShare', 'contact'],
    headline: 'Leave a public review',
    lede: 'Start with your email so the review carries your name. Three minutes, and it means the world to the team.',
    submitLabel: 'Send my review',
    consentText: 'I agree that Arctic Grey may publish this review exactly as I chose above, and may contact me about it.'
  },
  'audit': {
    source: 'audit-form',
    progressNote: 'Free · no obligation',
    contactHeadline: 'Last step. Who is the audit for?',
    topbar: 'Store audit',
    label: 'Audit',
    steps: ['welcome', 'name', 'storeUrl', 'platform', 'revenue', 'auditStore', 'auditStack', 'auditLenses', 'auditLeaks', 'auditContext', 'message', 'contact'],
    headline: 'Get your store audited.',
    lede: 'Start with your email. Our team reviews the store itself, so this stays short.',
    submitLabel: 'Request my audit',
    messageHeadline: 'What should the audit dig into?',
    messageLede: 'Conversion, speed, SEO, checkout, the whole thing. Tell us where it hurts.',
    consentText: 'I agree to Arctic Grey contacting me about this audit. No spam, no lists.'
  },
  'sponsors': {
    source: 'sponsors-form',
    progressNote: 'Estimates only · confirmed in your SOW',
    contactHeadline: 'Last step. Who is this estimate for?',
    topbar: 'Sponsored coverage',
    label: 'Sponsorship',
    steps: ['welcome', 'name', 'storeUrl', 'sponsorCalc', 'message', 'contact'],
    headline: 'How much of your build could our partners fund?',
    lede: 'Start with your email. Arctic Grey partners with apps we already run on merchant stores, and each one pays toward your build when you commit to running their program.',
    submitLabel: 'Send me the estimate',
    messageHeadline: 'Anything we should know?',
    messageLede: 'Optional. Tell us about the migration or build these programs would go toward.',
    consentText: 'I agree to Arctic Grey contacting me about this estimate. No spam, no lists.'
  },
  'bulk-hours': {
    source: 'bulk-hours-form',
    progressNote: 'Quote within 1 business day',
    contactHeadline: 'Last step. Who should the quote go to?',
    topbar: 'Bulk hours quote',
    label: 'Bulk hours',
    steps: ['welcome', 'name', 'storeUrl', 'revenue', 'budget', 'hoursEstimate', 'competitorsCard', 'assets', 'contact'],
    headline: 'Get your bulk hours quote.',
    lede: 'Start with your email. Tell us what needs doing and we come back with hours and a rate within 1 business day.',
    submitLabel: 'Request my quote',
    consentText: 'I agree to Arctic Grey contacting me about this quote. No spam, no lists.'
  },
  'abtest': {
    source: 'abtest-form',
    progressNote: 'Free · no obligation',
    contactHeadline: 'Last step. Who runs the tests with us?',
    topbar: 'A/B testing',
    label: 'A/B testing',
    steps: ['welcome', 'name', 'storeUrl', 'testPage', 'message', 'assets', 'contact'],
    headline: 'Start A/B testing your store.',
    lede: 'Start with your email. Tell us which page matters most and we design the first test around it.',
    submitLabel: 'Request my first test',
    messageHeadline: 'What do you want to learn?',
    messageLede: 'The doubt you want settled: layout, copy, offer, price presentation. Plain words are perfect.',
    consentText: 'I agree to Arctic Grey contacting me about A/B testing. No spam, no lists.'
  },
  'pos': {
    source: 'pos-form',
    progressNote: 'Free consultation',
    contactHeadline: 'Last step. Who runs point of sale?',
    topbar: 'POS consultation',
    label: 'POS',
    steps: ['welcome', 'name', 'storeUrl', 'platform', 'posSetup', 'message', 'contact'],
    headline: 'Get POS working with your store.',
    lede: 'Start with your email. Tell us about your locations and we map the setup with you.',
    submitLabel: 'Request my consultation',
    messageHeadline: 'Anything else about your retail setup?',
    messageLede: 'Hardware, staff count, existing systems, timelines. Whatever matters.',
    consentText: 'I agree to Arctic Grey contacting me about POS. No spam, no lists.'
  },
  'tech-stack': {
    source: 'tech-stack-form',
    progressNote: 'Free · no obligation',
    contactHeadline: 'Last step. Who owns the stack?',
    topbar: 'Tech stack review',
    label: 'Tech stack',
    steps: ['welcome', 'name', 'storeUrl', 'platform', 'revenue', 'appStack', 'message', 'contact'],
    headline: 'Get your tech stack reviewed.',
    lede: 'Start with your email. Tell us what you run today and we come back with what to keep, replace, or retire.',
    submitLabel: 'Request my stack review',
    messageHeadline: 'Where does the stack hurt?',
    messageLede: 'Syncing issues, double data entry, apps fighting each other, costs creeping up. Plain words are perfect.',
    consentText: 'I agree to Arctic Grey contacting me about this review. No spam, no lists.'
  },
  'marketing': {
    source: 'marketing-form',
    progressNote: 'Free · no obligation',
    contactHeadline: 'Last step. Who owns growth?',
    topbar: 'Marketing',
    label: 'Marketing',
    steps: ['welcome', 'name', 'storeUrl', 'revenue', 'channels', 'message', 'contact'],
    headline: 'Put our team behind your marketing.',
    lede: 'Start with your email. Tell us which channels are in play and we come back with where the growth is.',
    submitLabel: 'Request my growth plan',
    messageHeadline: 'What does growth look like for you?',
    messageLede: 'The number you want moved: revenue, ROAS, list size, repeat rate. And anything you have already tried.',
    consentText: 'I agree to Arctic Grey contacting me about marketing. No spam, no lists.'
  },
  'migration': {
    source: 'migration-form',
    progressNote: 'Nothing moves until you approve the plan',
    contactHeadline: 'Last step. Who runs the migration with us?',
    topbar: 'Shopify migration',
    label: 'Migration',
    steps: ['welcome', 'name', 'storeUrl', 'platform', 'revenue', 'launch', 'migrationScope', 'budget', 'assets', 'message', 'contact'],
    headline: 'Move to Shopify without losing a thing.',
    lede: 'Start with your email. Tell us what you run today and what has to survive the move, and we map the cleanest path off it.',
    submitLabel: 'Request my migration plan',
    messageHeadline: 'What cannot break in the move?',
    messageLede: 'Integrations, SEO rankings, subscriptions, gift cards, wholesale pricing. Name what would hurt most.',
    consentText: 'I agree to Arctic Grey contacting me about this migration. No spam, no lists.'
  },
  'b2b': {
    source: 'b2b-form',
    progressNote: 'Free consultation',
    contactHeadline: 'Last step. Who runs wholesale?',
    topbar: 'B2B and wholesale',
    label: 'B2B',
    steps: ['welcome', 'name', 'storeUrl', 'platform', 'revenue', 'launch', 'b2bSetup', 'message', 'contact'],
    headline: 'Get B2B and wholesale running on Shopify.',
    lede: 'Start with your email. Tell us how wholesale works today and we map it onto Shopify with you.',
    submitLabel: 'Request my consultation',
    messageHeadline: 'How does wholesale pricing work today?',
    messageLede: 'Price lists, net terms, minimums, per-customer catalogs. Whatever shapes an order.',
    consentText: 'I agree to Arctic Grey contacting me about B2B. No spam, no lists.'
  },
  'app': {
    source: 'app-form',
    progressNote: 'Scoped within 2 business days',
    contactHeadline: 'Last step. Who owns the app?',
    topbar: 'Shopify app project',
    label: 'App project',
    steps: ['welcome', 'name', 'storeUrl', 'appType', 'appBrief', 'appSurfaces', 'launch', 'message', 'contact'],
    headline: 'Build your Shopify app.',
    lede: 'Start with your email. Custom for one store, private for your org, or public on the App Store, we build all three.',
    submitLabel: 'Request my app scope',
    messageHeadline: 'What should the app do?',
    messageLede: 'The job in plain words. What it reads, what it writes, who uses it, and what exists today.',
    consentText: 'I agree to Arctic Grey contacting me about this app. No spam, no lists.'
  },
  'onboarding': {
    source: 'onboarding-form',
    progressNote: 'Your project, getting started',
    contactHeadline: 'Last step. Who is on the project?',
    topbar: 'Project onboarding',
    label: 'Onboarding',
    steps: ['welcome', 'name', 'storeUrl', 'revenue', 'launch', 'scope', 'budget', 'styleTiles', 'assets', 'message', 'contact'],
    headline: 'Let us get your project moving.',
    lede: 'Start with your email. Everything saves as you go, and anything you have told us before is already filled in.',
    submitLabel: 'Submit onboarding',
    messageHeadline: 'Anything else we should know?',
    messageLede: 'Deadlines, stakeholders, systems, constraints. Whatever matters to this project.',
    consentText: 'I agree to Arctic Grey contacting me about this project. No spam, no lists.'
  },
  /* Round 30 (2026-10-22): the last 123FormBuilder forms with no home here. Their
     uploads took any file type from anywhere; here they pass the region gate, the
     bot fingerprint and the upload vetting like every other form. */
  'careers': {
    source: 'careers-form',
    progressNote: 'Read by the hiring lead',
    contactHeadline: 'Last step. How do we reach you?',
    topbar: 'Careers',
    label: 'Careers',
    steps: ['welcome', 'name', 'careersRole', 'careersProfile', 'careersStory', 'assets', 'contact'],
    headline: 'Join Arctic Grey.',
    lede: 'Start with your email. A few minutes, fully remote, and the hiring lead reads every application.',
    submitLabel: 'Send my application',
    consentText: 'I agree to Arctic Grey keeping my application and contacting me about roles. No spam, no lists.',
    companyLabel: 'Current company',
    companyPlaceholder: 'Where you work today, if anywhere',
    companyOptional: true,
    hideRole: true,
    assetsHeadline: 'Your CV, if it is handy.',
    assetsLede: 'PDF or Word is perfect. Optional: your LinkedIn already counts, and a portfolio link works too.'
  },
  'partner-program': {
    source: 'partner-program-form',
    progressNote: 'Free to join · no obligations',
    contactHeadline: 'Last step. How do we reach you?',
    topbar: 'Partner program',
    label: 'Partner program',
    steps: ['welcome', 'name', 'partnerProfile', 'revenue', 'partnerPerks', 'message', 'contact'],
    headline: 'Become an Arctic Grey partner.',
    lede: 'Start with your email. Free to join, no obligations, and we only reach out about your application.',
    submitLabel: 'Apply to the program',
    messageHeadline: 'Anything else we should know?',
    messageLede: 'Optional. The stores you run, what they need next, or how you heard about us.',
    consentText: 'I agree to Arctic Grey contacting me about the partner program. No spam, no lists.',
    companyPlaceholder: 'The main store or brand you manage'
  },
  /* the team's tool for adding a client contact to Zendesk (was 123FormBuilder 6687316):
     the ticket it sends to support@ names the person as requester, and Zendesk
     creates their user from it. Not in the library: it is for staff, by link */
  'zendesk-user': {
    source: 'zendesk-user-form',
    progressNote: 'For the Arctic Grey team',
    contactHeadline: 'Last step. Confirm and send.',
    topbar: 'Add a Zendesk user',
    label: 'Zendesk user',
    steps: ['welcome', 'name', 'contact'],
    headline: 'Add someone to Zendesk.',
    lede: 'Start with their email. Their Zendesk user is created from the ticket this sends to support@arcticgrey.com.',
    submitLabel: 'Add to Zendesk',
    consentText: 'This person works with Arctic Grey and expects email from us.',
    companyLabel: 'Their company',
    companyPlaceholder: 'The client or partner they work with',
    companyOptional: true,
    hideRole: true
  }
};
var FORM_LIBRARY = [
  { group:'Start here', type:'audit', eyebrow:'Store review', title:'Store audit', time:'About 3 minutes',
    desc:'Our team reviews your store and comes back with what is costing you revenue.' },
  { group:'Start here', type:'migration', eyebrow:'Replatform', title:'Shopify migration', time:'About 3 minutes',
    desc:'Tell us what you run today and what must survive the move. We map the cleanest path off it.' },
  { group:'Start here', type:'test-drive', eyebrow:'Free working prototype', title:'Shopify Test Drive', time:'About 4 minutes',
    desc:'We build a working prototype of your store on Shopify in 5 business days. Keep the work either way.' },
  { group:'Start here', type:'app', eyebrow:'App build', title:'Custom Shopify app', time:'About 2 minutes',
    desc:'Public on the App Store to earn on its own, or private to run your business. Scoped within 2 business days.' },
  { group:'Build and grow', type:'onboarding', eyebrow:'New project', title:'Project onboarding', time:'About 6 minutes',
    desc:'The details we need to start building: platform, scope, budget, features, and your assets.' },
  { group:'Build and grow', type:'abtest', eyebrow:'CRO testing', title:'A/B testing', time:'About 2 minutes',
    desc:'Name the page that matters most and we design the first test around it.' },
  { group:'Build and grow', type:'marketing', eyebrow:'Growth', title:'Marketing', time:'About 2 minutes',
    desc:'Tell us which channels are in play and we come back with where the growth is.' },
  { group:'Run the business', type:'tech-stack', eyebrow:'Stack review', title:'Tech stack review', time:'About 2 minutes',
    desc:'List what you run and we come back with what to keep, replace, or retire.' },
  { group:'Run the business', type:'b2b', eyebrow:'Wholesale', title:'B2B and wholesale', time:'About 2 minutes',
    desc:'Tell us how wholesale works today and we map it onto Shopify with you.' },
  { group:'Run the business', type:'pos', eyebrow:'Retail', title:'POS consultation', time:'About 2 minutes',
    desc:'Tell us about your locations and we map the point of sale setup with you.' },
  { group:'Pricing and funding', type:'bulk-hours', eyebrow:'Priced quote', title:'Bulk hours quote', time:'About 3 minutes',
    desc:'Tell us your task list and we come back with hours, a blended rate, and a quote within 1 business day.' },
  { group:'Pricing and funding', type:'sponsors', eyebrow:'Partner funded', title:'Sponsorship estimate', time:'About 2 minutes',
    desc:'See how much of your build our partners could fund. Enter your numbers once and they follow you into every other form.' },
  { group:'Anything else', type:'contact', eyebrow:'Direct line', title:'Contact us', time:'Under a minute',
    desc:'A question, an introduction, or something that does not fit a box. It reaches the team directly.' },
  { group:'Anything else', type:'feedback', eyebrow:'Straight to leadership', title:'How can we improve', time:'About 2 minutes',
    desc:'Working with us already? Tell us what is working and what is not. Leadership reads every word.' },
  { group:'Anything else', type:'review', eyebrow:'Only with your say-so', title:'Leave a public review', time:'About 3 minutes',
    desc:'Happy with the work? Say it publicly. You choose exactly how much of your name travels with it.' },
  { group:'Anything else', type:'partner-program', eyebrow:'Free to join', title:'Partner program', time:'About 2 minutes',
    desc:'Run ecommerce for a brand? Join free, get our audit and Test Drive toolbox, and bring us the work your stores need.' },
  { group:'Anything else', type:'careers', eyebrow:'Join the team', title:'Careers', time:'About 4 minutes',
    desc:'Fully remote roles in engineering, design, project management, support and marketing. Apply in a few minutes.' }
];
var FORM_TYPE = (function(){
  try {
    var t = new URLSearchParams(location.search).get('form');
    if(FORM_TYPES[t]) return t;
    // /pages/form is the front door: with no parameter it opens the library
    return /\/form\/?$/.test(location.pathname) ? 'library' : 'test-drive';
  } catch (e) { return 'test-drive'; }
})();
var FORM_CFG = FORM_TYPES[FORM_TYPE];

/* What happens next, per form. Step one and three are the same promise everywhere;
   step two is the only thing that differs, because it is the only thing that does.
   A form with no entry here still gets an honest page rather than the Test Drive one. */
var THANKS_DEFAULT = {
  head: 'Got it. We are on it.',
  lede: 'Here is exactly what happens next.',
  outcome: 'We come back to you with what we found and what we would do about it.',
  cta: 'Book your call now',
  // only test-drive sends a confirmation, so only test-drive may invite a reply to one
  hint: 'Prefer email? Write to support@arcticgrey.com and it reaches the team directly.',
  cal: 'https://calendly.com/arcticgrey-jake/15min'
};
var THANKS = {
  feedback: {
    head: 'Thank you. It goes straight to the top.',
    outcome: 'Leadership reads every word, and if something needs fixing, we fix it.',
    cta: 'Talk it through instead',
    cal: 'https://calendly.com/arcticgrey-jake/15min',
    hint: 'Prefer email? Write to support@arcticgrey.com and it reaches the team directly.'
  },
  review: {
    head: 'Thank you. It means more than you know.',
    outcome: 'The team reads every review, and your words only ever appear where you said they could.',
    cta: 'Talk it through instead',
    cal: 'https://calendly.com/arcticgrey-jake/15min',
    hint: 'Want to add, change, or withdraw it later? Write to support@arcticgrey.com and we update it, no questions asked.'
  },
  'test-drive': {
    outcome: 'We build your working prototype. It lands within 5 business days.',
    cta: 'Book your walkthrough now',
    hint: 'Prefer email? Reply to the confirmation we just sent and it reaches the team directly.',
    cal: 'https://calendly.com/arcticgrey-jake/intro-build-a-new-shopify-store'
  },
  sponsors: {
    head: 'Estimate on its way.',
    outcome: 'We confirm your coverage with each partner and put the numbers in writing.',
    cta: 'Book your call now'
  },
  audit: {
    head: 'Audit requested.',
    outcome: 'We review the live store and write up what is costing you revenue.',
    cta: 'Book your call now',
    cal: 'https://calendly.com/arcticgrey-jake/ux-ui-audit'
  },
  onboarding: {
    head: 'Onboarding received.',
    outcome: 'We turn your answers into scope and timings, and flag anything still open.',
    cta: 'Book your kickoff call now',
    cal: 'https://calendly.com/brooke-and-anthony/shopify-project-launch'
  },
  'bulk-hours': {
    head: 'Quote requested.',
    outcome: 'We price your task list and send your quote within 1 business day.',
    cta: 'Book your call now',
    cal: 'https://calendly.com/arcticgrey-jake/bulk-hours-quote-request'
  },
  abtest: {
    head: 'Test requested.',
    outcome: 'We design your first test around the page you named and send it for your sign-off.',
    cta: 'Book your call now'
  },
  pos: {
    head: 'POS consultation requested.',
    outcome: 'We map your locations to a POS setup and send the recommendation in writing.',
    cta: 'Book your call now'
  },
  'tech-stack': {
    head: 'Stack review requested.',
    outcome: 'We audit what you run, flag overlaps and gaps, and put keep or replace calls in writing.',
    cta: 'Book your call now'
  },
  marketing: {
    head: 'Growth plan requested.',
    outcome: 'We review your channels and numbers and come back with where the growth is.',
    cta: 'Book your call now'
  },
  migration: {
    head: 'Migration plan requested.',
    outcome: 'We map the path off your current platform, with nothing lost on the way.',
    cta: 'Book your migration call now',
    cal: 'https://calendly.com/arcticgrey-jake/shopify-support-call-with-arctic-grey-clone'
  },
  b2b: {
    head: 'Consultation requested.',
    outcome: 'We map your wholesale setup onto Shopify and send the recommendation in writing.',
    cta: 'Book your call now',
    cal: 'https://calendly.com/arcticgrey-jake/30min'
  },
  app: {
    head: 'App scope requested.',
    outcome: 'We turn your brief into a scope with hours and a timeline, within 2 business days.',
    cta: 'Book your call now'
  },
  contact: {
    head: 'Message sent.',
    outcome: 'The right person picks it up directly, not a shared inbox nobody reads.',
    cta: 'Book a call instead'
  },
  /* an application is not a sales lead: no call is promised, only a read */
  careers: {
    head: 'Application received.',
    steps: [
      'The hiring lead reads your application.',
      'If the role is a fit, we reply to set up a first conversation.',
      'Meanwhile, every open role is on the careers page.'
    ],
    cta: 'See open roles',
    cal: 'https://arcticgrey.com/pages/careers',
    hint: 'Questions about a role? Write to support@arcticgrey.com and it reaches the team directly.'
  },
  'zendesk-user': {
    head: 'Sent to Zendesk.',
    steps: [
      'support@arcticgrey.com gets a ticket with them as the requester.',
      'Zendesk creates their user from that ticket within a minute or two.',
      'Reply on that ticket, or open a new one to them, from Zendesk.'
    ],
    cta: 'Add another person',
    cal: '/pages/form?form=zendesk-user',
    hint: 'Not showing up? Search Zendesk Customers for their email.'
  },
  'partner-program': {
    head: 'Partner application received.',
    outcome: 'We confirm your partner account and send your toolbox.',
    cta: 'Book your call now'
  }
};
function thanksCopy(){
  var t = THANKS[FORM_TYPE] || {};
  return {
    head: t.head || THANKS_DEFAULT.head,
    lede: t.lede || THANKS_DEFAULT.lede,
    steps: t.steps || [
      'Our team reviews your answers, usually the same business day.',
      t.outcome || THANKS_DEFAULT.outcome,
      'We set up a call to go through it together, at a time that suits you.'
    ],
    cta: t.cta || THANKS_DEFAULT.cta,
    hint: t.hint || THANKS_DEFAULT.hint,
    cal: t.cal || THANKS_DEFAULT.cal
  };
}

/* Copy on the shared steps. Same rule as the thank-you page: the default has to read
   correctly on a form nobody has built yet, and the form that wants to say "prototype"
   asks for it by name. */
var COPY_DEFAULT = {
  nameLede: 'Your project gets a real team. They like knowing who they are building for.',
  contactLede: 'Your role routes this to the right conversation.',
  phoneHint: '\u00b7 optional, so we can reach you quickly'
};
var COPY = {
  'test-drive': {
    nameLede: 'Your prototype gets a real team. They like knowing who they are building for.',
    contactLede: 'Your role routes the prototype review to the right conversation.',
    phoneHint: '\u00b7 optional, for the prototype walkthrough'
  },
  contact: { contactLede: 'A couple of details so the reply lands with the right person.' },
  careers: {
    nameLede: 'The hiring lead likes knowing whose application they are reading.',
    contactLede: 'One tap on consent and your application is in.',
    phoneHint: '\u00b7 optional, in case the role moves fast'
  },
  'partner-program': { nameLede: 'Your partner account carries your name and the store you run.' },
  'zendesk-user': {
    nameLede: 'Their name, as Zendesk should show it.',
    contactLede: 'One tap to confirm, and the ticket goes to support@.',
    phoneHint: '\u00b7 optional, saved on their ticket'
  }
};
function stepCopy(k){
  var c = COPY[FORM_TYPE] || {};
  return c[k] || COPY_DEFAULT[k];
}

var DEBOUNCE_MS = 800, MAX_WAIT_MS = 3000, BACKOFF_MAX = 20000;
/* Keys are per form type: the device may hold one open row per form, and a second
   form must never adopt or overwrite the first one's. lastEmail stays device-wide
   because it identifies the person, not the form. Drafts key by submission id. */
var LS = {
  lastEmail: 'ag_td_last_email',
  sub: 'ag_td_submission_id_' + FORM_TYPE,
  draft: 'ag_td_draft_',
  index: 'ag_td_email_index_' + FORM_TYPE,
  queue: 'ag_td_pending_queue_' + FORM_TYPE,
  attr: 'ag_td_attribution'
};

var form = document.getElementById('tdForm');
var savePill = document.getElementById('savePill');
var toastEl = document.getElementById('toast');
var live = document.getElementById('liveRegion');

/* storage that survives blocked localStorage (embedded or restricted contexts) */
var mem = {};
var store = {
  get: function(k){ try{ return localStorage.getItem(k); }catch(e){ return (k in mem) ? mem[k] : null; } },
  set: function(k, v){ try{ localStorage.setItem(k, v); }catch(e){ mem[k] = v; } }
};

/* ---------- attribution capture (persist first-touch, URL wins) ---------- */
var ATTR_IDS = ['gclid','wbraid','gbraid','li_fat_id','fbclid','ttclid','msclkid','_kx',
                'utm_source','utm_medium','utm_campaign','utm_content','utm_term','c','cta'];

/* one name for where a person came from, derived from the strongest signal:
   a click id beats a utm, a utm beats a referrer, a referrer beats nothing */
function classifyChannel(a){
  a = a || {};
  var src = String(a.utm_source||'').toLowerCase(), med = String(a.utm_medium||'').toLowerCase(),
      ref = String(a.referrer||'').toLowerCase();
  if(a.gclid || a.wbraid || a.gbraid) return (src==='youtube'||med==='video') ? 'YouTube Ads' : 'Google Ads';
  if(a.li_fat_id) return 'LinkedIn Ads';
  if(a.fbclid) return (src==='instagram') ? 'Instagram Ads' : 'Meta Ads';
  if(a.ttclid) return 'TikTok Ads';
  if(a.msclkid) return 'Microsoft Ads';
  if(a._kx || src==='klaviyo') return 'Klaviyo email';
  if(src==='resend' || src==='factory' || src==='cae' || a.c) return 'Arctic Grey outbound email';
  if(src==='adroll' || med==='retargeting') return 'AdRoll';
  if(src==='youtube' || /youtube\.|youtu\.be/.test(ref)) return 'YouTube';
  if(src==='linkedin' || /linkedin\.|lnkd\.in/.test(ref)) return 'LinkedIn';
  if(src==='facebook' || src==='instagram' || src==='meta' || /facebook\.|instagram\.|fb\.me/.test(ref)) return 'Meta organic';
  if(src==='twitter' || src==='x' || /twitter\.|\bt\.co\//.test(ref)) return 'X';
  if(med==='email' || src.indexOf('mail')!==-1) return 'Email: ' + (src || 'unknown sender');
  if(/google\.[a-z.]+\//.test(ref)) return 'Google search';
  if(/bing\.com/.test(ref)) return 'Bing search';
  if(ref && ref.indexOf(location.hostname)===-1) return 'Referral: ' + ref.replace(/^https?:\/\//,'').split('/')[0];
  if(src) return 'Campaign: ' + src + (med ? ' / ' + med : '');
  return 'Direct or internal';
}
function touchToLine(t){
  if(!t || !t.ts) return '';
  var idBits = ATTR_IDS.filter(function(k){ return t[k] && k !== 'utm_content' && k !== 'utm_term' && k !== 'cta'; })
    .map(function(k){ return k + '=' + String(t[k]).slice(0,40); }).join(' ');
  return new Date(t.ts).toISOString().slice(0,16) + ' | ' + classifyChannel(t) + ' | landed ' +
         String(t.landing||'').slice(0,120) + (t.referrer ? ' | from ' + String(t.referrer).slice(0,80) : '') +
         (idBits ? ' | ' + idBits : '');
}
/* the site door: remember the very first arrival forever, and the latest arrival
   that carried marketing signals. The theme writes these on every page; the form
   writes them too because ads often land straight here. */
function recordTouches(){
  try{
    var p = new URLSearchParams(location.search);
    var t = {}, hot = false;
    ATTR_IDS.forEach(function(k){ var v = p.get(k); if(v){ t[k] = v; hot = true; } });
    var ext = document.referrer && document.referrer.indexOf(location.hostname) === -1;
    if(ext){ t.referrer = document.referrer; hot = true; }
    t.ts = Date.now();
    t.landing = (location.pathname + location.search).slice(0, 200);
    if(!localStorage.getItem('ag_first_touch')) localStorage.setItem('ag_first_touch', JSON.stringify(t));
    if(hot) localStorage.setItem('ag_last_touch', JSON.stringify(t));
  }catch(e){}
}
recordTouches();
function captureAttribution(){
  var p = new URLSearchParams(location.search);
  var stored = {};
  try{ stored = JSON.parse(store.get(LS.attr) || '{}'); }catch(e){}
  ATTR_IDS.forEach(function(k){ var v = p.get(k); if(v) stored[k] = v; });
  if(!stored.referrer && document.referrer) stored.referrer = document.referrer;
  if(!stored.landing) stored.landing = location.pathname + location.search;
  store.set(LS.attr, JSON.stringify(stored));
  return stored;
}
var attribution = captureAttribution();

/* location and network from our own edge, fetched once and attached to every
   save. Never blocks anything; a lead with no geo is still a lead. */
/* invisible bot check: the widget runs quietly at load and again shortly
   before submit, so the completion payload carries a fresh token. Verification
   happens on the backend; a missing or failed token never blocks anyone */
window.__agTs = { token: '', ts: 0, wid: null };
window.__agTsReady = function(){
  try{
    var host = document.createElement('div');
    host.style.cssText = 'position:fixed;left:-9999px;bottom:0';
    document.body.appendChild(host);
    window.__agTs.wid = turnstile.render(host, {
      sitekey: '0x4AAAAAAEW2I2-xiJxL1TkL',
      action: 'turnstile-spin-v1',
      callback: function(t){ window.__agTs.token = t; window.__agTs.ts = Date.now(); },
      'expired-callback': function(){ window.__agTs.token = ''; },
      'error-callback': function(){}
    });
  }catch(e){}
};
window.__agTsFresh = function(){
  try{
    if(window.__agTs.wid !== null && (!window.__agTs.token || Date.now() - window.__agTs.ts > 110000)) turnstile.reset(window.__agTs.wid);
  }catch(e){}
};
window.__agGeo = null;
try{
  fetch('https://test-drive.arcticgrey.org/whoami', {cache:'no-store'})
    .then(function(r){ return r.json(); })
    .then(function(g){ if(g && g.ok){ window.__agGeo = g; if(typeof regionGate_ === 'function') regionGate_(); } })
    .catch(function(){});
}catch(e){}
function deviceSummary(){
  try{
    var ua = navigator.userAgent;
    var os = /Windows/.test(ua) ? 'Windows' : /Mac OS X/.test(ua) ? 'Mac' : /Android/.test(ua) ? 'Android' : /iPhone|iPad/.test(ua) ? 'iOS' : /Linux/.test(ua) ? 'Linux' : 'Unknown OS';
    var br = /Edg\//.test(ua) ? 'Edge' : /OPR\//.test(ua) ? 'Opera' : /Firefox\//.test(ua) ? 'Firefox' : /Chrome\//.test(ua) ? 'Chrome' : /Safari\//.test(ua) ? 'Safari' : 'Unknown browser';
    var kind = /Mobi|Android|iPhone/.test(ua) ? 'phone' : /iPad|Tablet/.test(ua) ? 'tablet' : 'desktop';
    var net = (navigator.connection && navigator.connection.effectiveType) ? ' · ' + navigator.connection.effectiveType : '';
    var langs = (navigator.languages || [navigator.language]).slice(0, 2).join(', ');
    return os + ' · ' + br + ' · ' + kind + ' · ' + screen.width + 'x' + screen.height + net + ' · ' + langs;
  }catch(e){ return ''; }
}

/* ---------- state ---------- */
function uuid(){ return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,function(c){var r=Math.random()*16|0;return (c==='x'?r:(r&3|8)).toString(16);}); }
var submissionId = store.get(LS.sub);
/* a completed submission is a record: coming back starts fresh rather than
   silently rewriting what was already sent to the team */
if(submissionId){
  try{
    var bootDraft = JSON.parse(store.get(LS.draft + submissionId) || '{}');
    if(bootDraft.completed) submissionId = '';
  }catch(e){}
}
if(!submissionId){ submissionId = uuid(); store.set(LS.sub, submissionId); }

var state = {};   /* field name -> value (arrays pipe-joined at send) */
var kickoffSent = false;
var completed = false;

/* ---------- step engine ---------- */
var STEPS = ['library','welcome','situation','name','storeUrl','platform','revenue','launch','scope','budget','sponsorInterest','sponsorCalc','designGate','styleTiles','sliders','latitude','features','ai','assets','featureThis','oneThing','appStack','channels','migrationScope','b2bSetup','appType','appBrief','appSurfaces','auditStore','auditStack','auditLenses','auditLeaks','auditContext','feedbackContact','feedbackMood','feedbackScorecard','feedbackWords','reviewRating','reviewWords','reviewShare','hoursEstimate','competitorsCard','testPage','posSetup','careersRole','careersProfile','careersStory','partnerProfile','partnerPerks','message','contact','thanks'];
var stepEls = {};
STEPS.forEach(function(id){ stepEls[id] = form.querySelector('[data-step="'+id+'"]'); });
var current = 'welcome';

/* entry-point copy overrides */
(function applyFormType(){
  if(FORM_CFG.topbar){ var tb = document.querySelector('.topbar-label'); if(tb) tb.textContent = FORM_CFG.topbar; }
  var pn = document.getElementById('progressNote');
  if(pn && FORM_CFG.progressNote) pn.textContent = FORM_CFG.progressNote;
  if(FORM_CFG.chrome === false){
    document.querySelector('.progress-wrap').style.display = 'none';
    savePill.style.display = 'none';
    document.body.classList.add('is-bare');
    var tools = document.querySelector('.tb-tools');
    if(tools) tools.style.display = 'none';
  }
  if(FORM_TYPE !== 'library'){
    // every form gets the shared-step copy, so a new one cannot inherit "prototype"
    var nl = stepEls.name && stepEls.name.querySelector('.lede');
    if(nl) nl.textContent = stepCopy('nameLede');
    var ph = document.getElementById('phoneOptional');
    if(ph) ph.textContent = stepCopy('phoneHint');
    var cl2 = stepEls.contact && stepEls.contact.querySelector('.lede');
    if(cl2) cl2.textContent = stepCopy('contactLede');
    document.title = (FORM_CFG.topbar || 'Arctic Grey form') + ' \u00b7 Arctic Grey';
    var tc = thanksCopy();
    var th = stepEls.thanks.querySelector('h2');
    if(th) th.textContent = tc.head;
    var tl = stepEls.thanks.querySelector('.lede');
    if(tl) tl.textContent = tc.lede;
    var tn = stepEls.thanks.querySelector('.next-steps');
    if(tn) tn.innerHTML = tc.steps.map(function(t, i){
      return '<li><span class="ns-num">' + (i + 1) + '</span><span>' + escHtml(t) + '</span></li>';
    }).join('');
    var tb = stepEls.thanks.querySelector('.btn-primary');
    if(tb){ tb.innerHTML = escHtml(tc.cta) + ' <span class="arrow">→</span>'; tb.href = tc.cal; }
    var thn = document.getElementById('tyHint');
    if(thn) thn.textContent = tc.hint;
  }
  if(FORM_TYPE === 'test-drive' || FORM_TYPE === 'library') return;
  var eb = stepEls.welcome.querySelector('.eyebrow');
  if(eb && FORM_CFG.topbar) eb.textContent = FORM_CFG.topbar;
  if(FORM_CFG.contactHeadline){
    var ch = stepEls.contact.querySelector('h2');
    if(ch) ch.textContent = FORM_CFG.contactHeadline;
  }
  if(FORM_CFG.headline){ var h1 = stepEls.welcome.querySelector('h1'); if(h1) h1.textContent = FORM_CFG.headline; }
  if(FORM_CFG.lede){ var ld = stepEls.welcome.querySelector('.lede'); if(ld) ld.textContent = FORM_CFG.lede; }
  if(FORM_CFG.submitLabel){ document.getElementById('submitBtn').textContent = FORM_CFG.submitLabel; }
  if(FORM_CFG.consentText){ var ct = document.querySelector('.consent-text'); if(ct) ct.textContent = FORM_CFG.consentText; }
  if(FORM_CFG.messageHeadline){ var mh = stepEls.message.querySelector('h2'); if(mh) mh.textContent = FORM_CFG.messageHeadline; }
  if(FORM_CFG.messageLede){ var ml = stepEls.message.querySelector('.lede'); if(ml) ml.textContent = FORM_CFG.messageLede; }
  if(FORM_CFG.companyLabel){
    var cLab = stepEls.name.querySelector('label[for="company"]');
    if(cLab) cLab.innerHTML = escHtml(FORM_CFG.companyLabel) + (FORM_CFG.companyOptional ? ' <span class="optional-tag">\u00b7 optional</span>' : '');
  }
  if(FORM_CFG.companyPlaceholder){ var cIn = document.getElementById('company'); if(cIn) cIn.placeholder = FORM_CFG.companyPlaceholder; }
  /* an applicant has no buying role to route by */
  if(FORM_CFG.hideRole){ var rg = stepEls.contact.querySelector('.chip-group[aria-label="Your role"]'); if(rg) rg.style.display = 'none'; }
  if(FORM_CFG.assetsHeadline){ var ah = stepEls.assets.querySelector('h2'); if(ah) ah.textContent = FORM_CFG.assetsHeadline; }
  if(FORM_CFG.assetsLede){ var al = document.getElementById('assetsLede'); if(al) al.textContent = FORM_CFG.assetsLede; }
})();

/* the library renders itself from the same config that drives the forms */
(function buildLibrary(){
  if(FORM_TYPE !== 'library') return;
  var base = location.pathname;
  var order = [], groups = {};
  FORM_LIBRARY.forEach(function(f){
    var g = f.group || 'More';
    if(!groups[g]){ groups[g] = []; order.push(g); }
    groups[g].push(f);
  });
  document.getElementById('flGrid').innerHTML = order.map(function(g, gi){
    var lead = gi === 0;
    return '<h2 class="fl-group-title">' + escHtml(g) + '</h2>' +
      '<div class="fl-grid' + (lead ? ' fl-grid--lead' : '') + '">' +
      groups[g].map(function(f){
        return '<a class="fl-card' + (lead ? ' fl-card--lead' : '') + '" href="' + base + '?form=' + f.type + '">' +
          '<span class="fl-eyebrow">' + escHtml(f.eyebrow) + '</span>' +
          '<span class="fl-title">' + escHtml(f.title) + '</span>' +
          '<span class="fl-desc">' + escHtml(f.desc) + '</span>' +
          '<span class="fl-foot">' + escHtml(f.time) + '<span class="fl-go">Open <span aria-hidden="true">→</span></span></span>' +
        '</a>';
      }).join('') + '</div>';
  }).join('');
})();

function budgetValue(){ var b = state.budget || ''; if(b === 'template') return 0; var n = parseInt(b,10); return isNaN(n) ? Infinity : n; }

function visibleSteps(){
  if(FORM_CFG.steps) return FORM_CFG.steps.slice();
  var v = ['welcome','situation','name','storeUrl'];
  if(state.situation === 'migrate') v.push('platform');
  v.push('revenue','launch','scope','budget');
  v.push('sponsorInterest');
  if(state.sponsor_interest === 'yes') v.push('sponsorCalc');
  v.push('designGate');
  if(state.design_gate === 'preferences') v.push('styleTiles','sliders','latitude');
  v.push('features','ai','assets','featureThis','oneThing','contact');
  return v;
}

function stepTitle(id){
  var h = stepEls[id].querySelector('h1,h2');
  return h ? h.textContent.trim() : id;
}

function renderProgress(){
  var v = visibleSteps();
  var i = v.indexOf(current);
  if(current === 'thanks'){ i = v.length; }
  var total = v.length;
  var pct = current === 'thanks' ? 100 : Math.round((i/(total)) * 100);
  document.getElementById('progressFill').style.width = pct + '%';
  var label = current === 'thanks' ? 'Done' : 'Step ' + (i+1) + ' of ' + total;
  document.getElementById('progressLabel').textContent = label;
  live.textContent = label + (current !== 'thanks' ? ': ' + stepTitle(current) : '');
}

/* the team search: start typing a name, pick from the suggestions, and the
   matching chip selects itself. The chips remain the tap path; this is the
   fast lane for people who know exactly who they work with */
(function(){
  var input = document.getElementById('agContactSearch');
  var box = document.getElementById('agContactSuggest');
  if(!input || !box) return;
  var items = [].slice.call(document.querySelectorAll('input[name="ag_contact"]')).map(function(r){
    return { value: r.value, input: r };
  });
  function render(q){
    var t = q.trim().toLowerCase();
    if(!t){ box.hidden = true; box.innerHTML = ''; return; }
    var hits = items.filter(function(i){ return i.value !== 'Not sure' && i.value.toLowerCase().indexOf(t) !== -1; }).slice(0, 6);
    if(!hits.length){ box.hidden = true; box.innerHTML = ''; return; }
    box.innerHTML = hits.map(function(i){ return '<button type="button" data-v="' + escHtml(i.value) + '">' + escHtml(i.value) + '</button>'; }).join('');
    box.hidden = false;
  }
  input.addEventListener('input', function(){ render(input.value); });
  input.addEventListener('keydown', function(e){
    if(e.key === 'Enter'){ e.preventDefault(); e.stopPropagation(); var first = box.querySelector('button'); if(first && !box.hidden) first.click(); }
    if(e.key === 'Escape'){ box.hidden = true; }
  });
  box.addEventListener('click', function(e){
    var b = e.target.closest('button'); if(!b) return;
    var hit = items.filter(function(i){ return i.value === b.getAttribute('data-v'); })[0];
    if(hit){ hit.input.checked = true; hit.input.dispatchEvent(new Event('change', {bubbles:true})); input.value = hit.value; }
    box.hidden = true;
  });
  document.addEventListener('click', function(e){ if(!box.contains(e.target) && e.target !== input) box.hidden = true; });
})();
/* the where-may-it-appear chips only make sense for a review that gets published;
   picking keep-it-internal hides them and clears any picks, restored state included */
/* when the store is brand new there is nothing to scan, so the products step
   carries the weight and says so */
window.__syncFeatureProducts = function(){
  var lede = document.getElementById('featureLede');
  if(!lede) return;
  lede.textContent = newStoreCase_()
    ? 'Your store is brand new, so there is nothing for us to scan. This is the one thing we truly need: the products, in names, links, or a plain description.'
    : 'Your heroes. Best sellers, highest margin, the ones you would put in the window. Optional, but this is where prototypes get personal.';
};
window.__syncReviewChannels = function(){
  var wrap = document.getElementById('reviewChannelsWrap');
  if(!wrap) return;
  var perm = form.querySelector('input[name="review_permission"]:checked');
  var hide = perm && perm.value === 'private';
  wrap.style.display = hide ? 'none' : '';
  if(hide){
    form.querySelectorAll('input[name="review_channels"]:checked').forEach(function(c){
      c.checked = false; syncVisual(c);
    });
  }
};
form.addEventListener('change', function(e){
  if(e.target && e.target.name === 'review_permission') window.__syncReviewChannels();
});
/* the earn question only exists for a public app; it appears the moment public
   is picked and disappears with it, restored state included */
window.__syncAppMonetize = function(){
  var wrap = document.getElementById('appMonetizeWrap');
  if(!wrap) return;
  var pub = form.querySelector('input[name="app_type"][value="public"]');
  wrap.style.display = (pub && pub.checked) ? 'block' : 'none';
};
form.addEventListener('change', function(e){
  if(e.target && e.target.name === 'app_type') window.__syncAppMonetize();
});
function show(id, focusHeading){
  if(id === 'appStack' && window.__syncStackDomain) window.__syncStackDomain();
  if(id === 'appType' && window.__syncAppMonetize) window.__syncAppMonetize();
  if(id === 'reviewShare' && window.__syncReviewChannels) window.__syncReviewChannels();
  if(id === 'featureThis' && window.__syncFeatureProducts) window.__syncFeatureProducts();
  if(id === 'contact' && window.__agTsFresh) window.__agTsFresh();
  /* moving off the name step with the guess still showing is acceptance: from
     here on it saves like anything the person typed */
  if(current === 'name'){ var cgA = document.getElementById('company'); if(cgA) delete cgA.dataset.guessed; }
  var prev = stepEls[current];
  if(prev) prev.classList.remove('is-active');
  current = id;
  var el = stepEls[id];
  el.classList.add('is-active');
  renderProgress();
  if(typeof sdDrawer !== 'undefined' && sdDrawer && sdDrawer.classList.contains('is-open')) sdRender();
  if(focusHeading !== false){
    var h = el.querySelector('h1,h2');
    if(h){ h.setAttribute('tabindex','-1'); h.focus({preventScroll:false}); }
  }
  window.scrollTo({top:0, behavior: PREFERS_REDUCED ? 'auto' : 'smooth'});
  if(typeof brandDraft === 'function') brandDraft();
  if(id === 'styleTiles' && typeof applyBrandDraft === 'function') applyBrandDraft();
}

function next(){
  if(!validate(current)) return;
  collectStep(current);
  var v = visibleSteps();
  var i = v.indexOf(current);
  /* landing off the list must never dead-end: fall back to the start */
  if(i === -1){ show(v[0]); forceSave(); return; }
  if(i === v.length - 1){ forceSave(); return; }
  /* save after the move so current_step records where the person IS, not where
     they were: resume and the abandonment link land on the unanswered step */
  show(v[i+1]);
  forceSave();
}
function back(){
  var v = visibleSteps();
  var i = v.indexOf(current);
  if(i === -1){ show(v[0]); return; }
  if(i > 0) show(v[i-1]);
}

form.addEventListener('click', function(e){
  var t = e.target.closest('[data-next],[data-back]');
  if(!t) return;
  e.preventDefault();
  if(!t.hasAttribute('data-next')) { back(); return; }
  /* The gate holds until the record check has spoken: the person watches us
     search, reads found or fresh, and only then does the form open, already
     filled in. Restores land while the message shows, so nothing is ever blank. */
  if(current === 'welcome' && !LOOKUP.done && typeof gateStart === 'function'){
    if(!validate(current)) return;
    collectStep(current);
    LOOKUP.targetStep = '';
    var localHit = tryResume();
    gateStart(t, localHit).then(function(r){
      var restored = r.found || r.count > 0;
      /* long enough to read the verdict, short enough to feel snappy */
      setTimeout(function(){
        if(current !== 'welcome') return; /* they used Back and moved on */
        if(LOOKUP.targetStep && visibleSteps().indexOf(LOOKUP.targetStep) !== -1){
          show(LOOKUP.targetStep);
        } else {
          next();
        }
      }, restored ? 1600 : 1200);
    });
    return;
  }
  next();
});
form.addEventListener('keydown', function(e){
  if(e.key === 'Enter' && e.target.tagName !== 'TEXTAREA' && e.target.type !== 'button'){
    e.preventDefault();
    if(current === 'contact'){ document.getElementById('submitBtn').click(); }
    else if(current === 'welcome'){ var wb = document.querySelector('[data-step="welcome"] [data-next]'); if(wb) wb.click(); else next(); }
    else if(current !== 'thanks'){ next(); }
  }
});

/* ---------- validation (email, situation, name, url only) ---------- */
var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
var ERR_INPUT = {emailError:'email', nameError:'firstName', companyError:'company', urlError:'storeUrl', appDescError:'appDescription', featureError:'featureProducts'};
function setErr(id, on){
  var el = document.getElementById(id);
  if(el) el.classList.toggle('is-on', !!on);
  var inp = ERR_INPUT[id] && document.getElementById(ERR_INPUT[id]);
  if(inp){ if(on){ inp.setAttribute('aria-invalid','true'); } else { inp.removeAttribute('aria-invalid'); } }
}
/* the substance bar: required text must be a real answer, not a name typed into
   the box. At least 30 characters and 4 words, and never just their own name,
   company, or email echoed back (the Omar Gray case, Zendesk 1118243166). */
function realAnswer_(text){
  var d = String(text || '').trim();
  if(d.length < 30) return false;
  if(d.split(/\s+/).filter(function(w){ return w; }).length < 4) return false;
  var lower = d.toLowerCase();
  var echoes = [
    (document.getElementById('firstName')||{}).value, (document.getElementById('lastName')||{}).value,
    (document.getElementById('company')||{}).value, String((document.getElementById('email')||{}).value||'').split('@')[0]
  ];
  for(var i = 0; i < echoes.length; i++){
    if(echoes[i] && lower === String(echoes[i]).trim().toLowerCase()) return false;
  }
  return true;
}
/* a profile link: a host with a dot, scheme optional, so linkedin.com/in/x passes */
function urlShaped_(v){
  var u = String(v || '').trim();
  if(!u) return false;
  if(!/^https?:/i.test(u)) u = 'https://' + u;
  return /^https?:\/\/[^\s\/]+\.[a-z0-9]{2,}([\/?#]|$)/i.test(u);
}
/* a brand new store leaves nothing to scan, so the products become required */
function newStoreCase_(){
  var ns = form.querySelector('input[name="no_site"]');
  return state.situation === 'new_store' || (ns && ns.checked);
}
/* Round 27 (2026-10-19): what each form needs before it submits. A rule names
   its form, so a step shared by eight forms (revenue, launch, platform, budget)
   is required only where it is listed here and stays optional everywhere else.
   Every required choice has a "Not sure yet" answer that counts. The agent
   lane's missingFor mirrors this table. */
var REQUIRED_BY_FORM = {
  'test-drive': {revenue:1, launch:1, budget:1},
  migration: {platform:1, launch:1, migrationScope:1},
  audit: {platform:1, revenue:1, auditLenses:1},
  b2b: {b2bSetup:1, revenue:1},
  pos: {posSetup:1},
  'tech-stack': {appStack:1},
  marketing: {channels:1},
  'bulk-hours': {hoursEstimate:1}
};
function needs_(stepId){ var r = REQUIRED_BY_FORM[FORM_TYPE]; return !!(r && r[stepId]); }
function picked_(name){ return !!form.querySelector('input[name="' + name + '"]:checked'); }
function validateRequired_(id){
  var ok = true, err = '', focusEl = null;
  if(id === 'revenue'){ ok = picked_('revenue'); err = 'revenueError'; }
  else if(id === 'launch'){ ok = picked_('launch'); err = 'launchError'; }
  else if(id === 'budget'){ ok = !!document.getElementById('budget').value; err = 'budgetError'; focusEl = document.getElementById('budget'); }
  else if(id === 'platform'){ ok = !!(document.getElementById('platformHidden').value || '').trim(); err = 'platformError'; focusEl = document.getElementById('platformSearch'); }
  else if(id === 'migrationScope'){ ok = !!document.getElementById('skuCount').value; err = 'skuError'; focusEl = document.getElementById('skuCount'); }
  else if(id === 'auditLenses'){ ok = picked_('audit_focus'); err = 'lensError'; }
  else if(id === 'b2bSetup'){ ok = picked_('b2b_ordering'); err = 'b2bOrderError'; }
  else if(id === 'posSetup'){ ok = picked_('pos_locations') && picked_('pos_setup'); err = 'posError'; }
  else if(id === 'appStack'){
    /* one real entry is a stack: "Klaviyo" alone must pass */
    ok = String(document.getElementById('appsCurrent').value || '').split(/[\n,|]+/)
      .some(function(s){ return s.trim().length >= 2; });
    err = 'stackError'; focusEl = document.getElementById('sbSearch');
  }
  else if(id === 'channels'){ ok = picked_('channels'); err = 'channelsError'; }
  else if(id === 'hoursEstimate'){ ok = realAnswer_(document.getElementById('hoursTasks').value); err = 'hoursTasksError'; focusEl = document.getElementById('hoursTasks'); }
  if(err) setErr(err, !ok);
  if(!ok && focusEl) focusEl.focus();
  return ok;
}
function validate(id){
  if(needs_(id)) return validateRequired_(id);
  if(id === 'welcome'){
    var ok = EMAIL_RE.test((document.getElementById('email').value||'').trim());
    setErr('emailError', !ok);
    if(!ok) document.getElementById('email').focus();
    return ok;
  }
  if(id === 'situation'){
    var ok2 = !!form.querySelector('input[name="situation"]:checked');
    setErr('situationError', !ok2);
    return ok2;
  }
  if(id === 'name'){
    var ok3 = (document.getElementById('firstName').value||'').trim().length > 0;
    setErr('nameError', !ok3);
    /* contact and feedback only ever promised email and a name */
    var needCompany = FORM_TYPE !== 'contact' && FORM_TYPE !== 'feedback' && !FORM_CFG.companyOptional;
    var okC = !needCompany || (document.getElementById('company').value||'').trim().length > 0;
    setErr('companyError', !okC);
    if(!ok3){ document.getElementById('firstName').focus(); }
    else if(!okC){ document.getElementById('company').focus(); }
    return ok3 && okC;
  }
  if(id === 'storeUrl'){
    var noSite = form.querySelector('input[name="no_site"]').checked;
    /* if this form never asks the situation question the toggle would stay hidden */
    if(!noSite && visibleSteps().indexOf('situation') === -1){
      document.getElementById('noSiteToggle').style.display = 'flex';
    }
    var u = (document.getElementById('storeUrl').value||'').trim();
    var u2 = /^https?:/i.test(u) ? u : (u ? 'https://' + u : '');
    /* a real web address has a dot in its host; kingand/me does not */
    var shaped = /^https?:\/\/[^\s\/]+\.[a-z0-9]{2,}([\/?#]|$)/i.test(u2);
    var ok4 = noSite || (u.length > 3 && shaped);
    var urlErr = document.getElementById('urlError');
    if(urlErr) urlErr.textContent = (u && !shaped)
      ? 'That does not look like a web address. No site yet? Tick the box below.'
      : 'Drop in the URL, or tick the box below if there is no site yet.';
    setErr('urlError', !ok4);
    if(!ok4) document.getElementById('storeUrl').focus();
    if(ok4 && !noSite && u2 && u2 !== window.__agReachChecked){
      window.__agReachChecked = u2;
      try {
        fetch('https://test-drive.arcticgrey.org/reach?url=' + encodeURIComponent(u2))
          .then(function(r){ return r.json(); })
          .then(function(d){ var ri = document.getElementById('storeUrlReach'); if(ri && d && d.note){ ri.value = d.note; scheduleSave(); } })
          .catch(function(){});
      } catch(e) {}
    }
    return ok4;
  }
  if(id === 'appType'){
    var okA = !!form.querySelector('input[name="app_type"]:checked');
    setErr('appTypeError', !okA);
    return okA;
  }
  if(id === 'appBrief'){
    var okB = realAnswer_(document.getElementById('appDescription').value);
    setErr('appDescError', !okB);
    if(!okB) document.getElementById('appDescription').focus();
    return okB;
  }
  if(id === 'featureThis'){
    if(!newStoreCase_()) return true;
    var fp = (form.querySelector('[name="feature_products"]').value || '').trim();
    var okF = fp.length >= 8;
    setErr('featureError', !okF);
    if(!okF) form.querySelector('[name="feature_products"]').focus();
    return okF;
  }
  if(id === 'appSurfaces'){ return true; }
  if(id === 'auditStore' || id === 'auditStack' || id === 'auditLenses' || id === 'auditLeaks' || id === 'auditContext'){ return true; }
  if(id === 'feedbackContact' || id === 'feedbackMood' || id === 'feedbackScorecard' || id === 'feedbackWords'){ return true; }
  if(id === 'reviewRating'){
    var okR = !!document.querySelector('input[name="review_rating"]:checked');
    setErr('ratingError', !okR);
    return okR;
  }
  if(id === 'reviewWords'){
    var okW = (document.getElementById('reviewText').value || '').trim().length > 0;
    setErr('reviewTextError', !okW);
    if(!okW) document.getElementById('reviewText').focus();
    return okW;
  }
  if(id === 'reviewShare'){
    var okP = !!document.querySelector('input[name="review_permission"]:checked');
    setErr('permissionError', !okP);
    return okP;
  }
  if(id === 'careersRole'){
    var okCt = picked_('careers_team');
    var okCl = (document.getElementById('careersLocation').value || '').trim().length >= 2;
    setErr('careersTeamError', !okCt);
    setErr('careersLocationError', !okCl);
    if(okCt && !okCl) document.getElementById('careersLocation').focus();
    return okCt && okCl;
  }
  if(id === 'careersProfile'){
    var okLi = urlShaped_(document.getElementById('linkedinUrl').value);
    setErr('linkedinError', !okLi);
    if(!okLi) document.getElementById('linkedinUrl').focus();
    return okLi;
  }
  if(id === 'careersStory'){
    var okCs = realAnswer_(document.getElementById('careersStory').value);
    setErr('careersStoryError', !okCs);
    if(!okCs) document.getElementById('careersStory').focus();
    return okCs;
  }
  if(id === 'partnerProfile'){
    var okPp = picked_('pp_manager') && picked_('pp_stores');
    var okPl = urlShaped_(document.getElementById('ppLinkedin').value);
    setErr('partnerError', !okPp);
    setErr('ppLinkedinError', !okPl);
    if(okPp && !okPl) document.getElementById('ppLinkedin').focus();
    return okPp && okPl;
  }
  if(id === 'testPage'){
    var okT = (document.getElementById('testPage').value||'').trim().length > 2;
    setErr('testPageError', !okT);
    if(!okT) document.getElementById('testPage').focus();
    return okT;
  }
  return true;
}

/* ---------- collect ---------- */
function collectStep(){ collectAll(); }
var clearedSet = {};
function collectAll(){
  var fd = new FormData(form);
  var out = {};
  fd.forEach(function(val, key){
    if(out[key] !== undefined){ out[key] += ' | ' + val; } else { out[key] = val; }
  });
  ['email','first_name','last_name','company','store_url','loved_sites','asset_link','phone'].forEach(function(k){
    if(out[k]) out[k] = String(out[k]).trim();
  });
  /* competitors lives on two forms' steps; the empty twin must not join in */
  if(out.competitors !== undefined){
    out.competitors = String(out.competitors).split(' | ').map(function(s){ return s.trim(); }).filter(function(s){ return s; }).join(' | ');
  }
  var cgB = document.getElementById('company');
  if(cgB && cgB.dataset.guessed && out.company){ delete out.company; delete clearedSet.company; }
  out.files = (fileNames.length ? fileNames.join(' | ') : '');
  /* a field that had a value and now does not was cleared on purpose; the
     backend blanks it on our say-so rather than keeping the ghost forever */
  Object.keys(state || {}).forEach(function(k){
    if(state[k] !== '' && (out[k] === undefined || out[k] === '')) clearedSet[k] = 1;
  });
  Object.keys(out).forEach(function(k){ if(out[k] !== '') delete clearedSet[k]; });
  Object.keys(out).forEach(function(k){ if(out[k] === '') delete out[k]; });
  state = out;
  return out;
}

/* ---------- autosave engine (onboarding pattern) ---------- */
var saveTimer = null, maxWaitTimer = null, retryDelay = 1000, retryCount = 0, lastPostedHash = '';

function setPill(txt, cls){
  savePill.textContent = txt;
  savePill.className = 'save-pill' + (cls ? ' ' + cls : '');
}
function hashOf(obj){
  var clone = {}; Object.keys(obj).forEach(function(k){
    if(k!=='last_updated' && k!=='client_ts' && k!=='fill_ms' && k!=='viewport') clone[k]=obj[k];
  });
  return JSON.stringify(clone);
}
function buildPayload(extra){
  var p = collectAll();
  var body = Object.assign({}, p, extra || {}, {
    submission_id: submissionId,
    current_step: current,
    attribution: attribution,
    user_agent: navigator.userAgent,
    referrer: attribution.referrer || '',
    page_url: location.href,
    last_updated: new Date().toISOString(),
    client_ts: Date.now(),
    form_type: FORM_TYPE,
    cleared: Object.keys(clearedSet),
    source: FORM_CFG.source + (state.agent_prefill === 'yes' ? '-agent' : ''),
    geo_city: (window.__agGeo && window.__agGeo.city) || '',
    geo_region: (window.__agGeo && window.__agGeo.region) || '',
    geo_country: (window.__agGeo && (window.__agGeo.country_name || window.__agGeo.country)) || '',
    geo_postal: (window.__agGeo && window.__agGeo.postal) || '',
    geo_cc: (window.__agGeo && window.__agGeo.country) || '',
    geo_tz: (window.__agGeo && window.__agGeo.timezone) || '',
    geo_isp: (window.__agGeo && window.__agGeo.isp) || '',
    device_summary: deviceSummary(),
    entry_channel: (function(){
      var ft = null, lt = null;
      try{ ft = JSON.parse(localStorage.getItem('ag_first_touch') || 'null'); }catch(e){}
      try{ lt = JSON.parse(localStorage.getItem('ag_last_touch') || 'null'); }catch(e){}
      /* the strongest live signal wins: current session ids, then last touch,
         then the first visit ever */
      var now = classifyChannel(attribution);
      if(now !== 'Direct or internal') return now;
      if(lt){ var c2 = classifyChannel(lt); if(c2 !== 'Direct or internal') return c2; }
      return classifyChannel(ft || {});
    })(),
    first_touch: (function(){ try{ return touchToLine(JSON.parse(localStorage.getItem('ag_first_touch') || 'null')); }catch(e){ return ''; } })(),
    last_touch: (function(){ try{ return touchToLine(JSON.parse(localStorage.getItem('ag_last_touch') || 'null')); }catch(e){ return ''; } })(),
    form_version: FORM_VERSION,
    fill_start_ts: fillStartTs,
    fill_ms: Math.max(0, Date.now() - fillStartTs),
    timezone: (function(){ try{ return Intl.DateTimeFormat().resolvedOptions().timeZone || ''; }catch(err){ return ''; } })(),
    locale: navigator.language || '',
    viewport: window.innerWidth + 'x' + window.innerHeight
  });
  /* once this submission is in, every later body for it says so. The thank-you
     page's own page-hide save used to overtake the submit and get the submit
     dropped as stale, logging real leads as "left off at thanks" (Oct 2026) */
  if(completedId && body.submission_id === completedId){
    body.completed = true;
    if(completedExtra.consent_ts) body.consent_ts = completedExtra.consent_ts;
    if(completedExtra.turnstile_token) body.turnstile_token = completedExtra.turnstile_token;
  }
  return body;
}
var completedId = '', completedExtra = {};
var TAB_NONCE = uuid().slice(0, 8);
var seqCounter = 0;
/* a completed row is a record: edits that arrive after completion carry on
   under a new submission id, with the full current snapshot, so nothing typed
   is ever discarded to protect a closed row */
function rotateSubmission(){
  var fresh = uuid();
  submissionId = fresh;
  store.set(LS.sub, fresh);
  fillStartTs = Date.now(); /* a fresh submission is a fresh fill: the clock restarts */
  var nb = buildPayload();
  delete nb.completed; delete nb.consent_ts;
  try{
    var em = String(nb.email || '').toLowerCase();
    if(em){ var idx = emailIndex(); idx[em] = fresh; store.set(LS.index, JSON.stringify(idx)); }
  }catch(e){}
  try{ store.set(LS.draft + fresh, JSON.stringify(nb)); }catch(e){}
  enqueue(nb);
}
function enqueue(body){
  if(regionBlocked) return;
  body._qid = TAB_NONCE + '-' + (++seqCounter);
  var q = readQueue();
  q = q.filter(function(item){ return item.kickoff || item.completed || item.submission_id !== body.submission_id || (item._qid || '').indexOf(TAB_NONCE) !== 0; });
  q.push(body);
  store.set(LS.queue, JSON.stringify(q));
}
window.addEventListener('storage', function(e){
  if(e.key && e.key.indexOf('ag_td_pending_queue') === 0) drainQueue();
});
function readQueue(){
  try{ return JSON.parse(store.get(LS.queue) || '[]'); }catch(e){ return []; }
}
var draining = false;
function drainQueue(){
  if(draining) return;
  var q = readQueue();
  if(!q.length){ return; }
  draining = true;
  var body = q[0];
  send(body).then(function(res){
    /* re-read: another save may have enqueued while this one was in flight, and a
       stale write-back here silently deleted it and then claimed all was saved */
    var q2 = readQueue();
    var iSent = -1;
    for(var qi = 0; qi < q2.length; qi++){
      if(body._qid ? q2[qi]._qid === body._qid : (q2[qi].client_ts === body.client_ts && q2[qi].submission_id === body.submission_id)){ iSent = qi; break; }
    }
    if(iSent !== -1) q2.splice(iSent, 1);
    store.set(LS.queue, JSON.stringify(q2));
    q = q2;
    draining = false;
    retryDelay = 1000; retryCount = 0;
    var refused = (res && res.ok === false) ? res.error : '';
    if(refused === 'completed' && !body.completed){
      /* the row closed underneath this edit (submitted, or finished on another
         device): the edit moves onto a fresh submission instead of vanishing
         behind a saved checkmark. Rotation happens once: the snapshot reads the
         live screen, so queued saves still naming the dead id fold into it and
         are simply dropped rather than minting a row each */
      if(body.submission_id === submissionId) rotateSubmission();
      drainQueue();
      return;
    }
    if(refused === 'stale'){
      var tries = (body._staleRetries || 0) + 1;
      if(tries <= 2){
        var nb = buildPayload();
        nb._staleRetries = tries;
        enqueue(nb);
        drainQueue();
      } else {
        setPill('Could not save the last change', 'is-issue');
        if(q.length) drainQueue();
      }
      return;
    }
    setPill('All changes saved ✓ ' + new Date().toLocaleTimeString([], {hour:'numeric', minute:'2-digit'}), 'is-saved');
    if(completed && !q.length){
      var sy = document.getElementById('tySync');
      if(sy){ sy.textContent = 'Submission synced ✓'; sy.classList.add('is-saved'); }
      try {
        if (typeof gtag === 'function' && !window.__agTestDriveConvFired) {
          window.__agTestDriveConvFired = true;
          /* per-form actions land here as the ads account creates them; an empty
             map falls back to the blended lead action */
          var ADS_LABELS = {};
          gtag('event', 'conversion', {'send_to': ADS_LABELS[FORM_TYPE] || 'AW-11029526961/E4r2COnV788cELHzpIsp'});
        }
      } catch (e) {}
    }
    if(q.length) drainQueue();
  }).catch(function(){
    draining = false;
    retryCount++;
    if(navigator.onLine === false){
      setPill('Offline, answers saved on this device', 'is-issue');
    } else if(retryCount > 3){
      setPill('Sync issue, retrying (' + retryCount + ')', 'is-issue');
    }
    setTimeout(drainQueue, retryDelay);
    retryDelay = Math.min(retryDelay * 2, BACKOFF_MAX);
  });
}
function send(body){
  if(DEMO_MODE){
    return new Promise(function(res){
      setTimeout(function(){
        store.set(LS.draft + body.submission_id, JSON.stringify(body));
        res();
      }, 250);
    });
  }
  var ctl = new AbortController();
  var watchdog = setTimeout(function(){ ctl.abort(); }, 25000);
  return fetch(ENDPOINT, {
    method:'POST',
    headers:{'Content-Type':'text/plain;charset=utf-8'},
    credentials:'omit', redirect:'follow', cache:'no-store', mode:'cors',
    body: JSON.stringify(body), signal: ctl.signal
  }).then(function(r){
    clearTimeout(watchdog);
    if(!r.ok) throw new Error('http ' + r.status);
    return r.json().catch(function(){ return {}; }).then(function(d){
      /* the backend reports failure inside a 200; a busy lock must retry, while a
         row that is already submitted or superseded is done, not retryable */
      if(d && d.ok === false){
        if(d.error === 'busy') throw new Error('busy');
        /* refusals are not success: the caller decides how to recover */
        if(d.error === 'completed' || d.error === 'stale') return d;
        throw new Error(d.error || 'server');
      }
      return d || {};
    });
  });
}
var autosaveBlocked = false; /* true while a remote-resume lookup is in flight */
function scheduleSave(){
  if(autosaveBlocked || regionBlocked) return;
  setPill('Auto-saving…');
  clearTimeout(saveTimer);
  saveTimer = setTimeout(flushSave, DEBOUNCE_MS);
  if(!maxWaitTimer) maxWaitTimer = setTimeout(flushSave, MAX_WAIT_MS);
}
/* how many real answers a payload carries, ignoring identity, meta and the
   bookkeeping the engine writes on every save. Used to stop an empty autosave
   from overwriting a fuller draft on the same submission id. */
var META_KEYS = {submission_id:1,current_step:1,attribution:1,user_agent:1,referrer:1,page_url:1,
  last_updated:1,client_ts:1,form_type:1,cleared:1,source:1,consent:1,consent_ts:1,filled_by:1,
  agent_prefill:1,_qid:1,_staleRetries:1,entry_channel:1,first_touch:1,last_touch:1,
  geo_city:1,geo_region:1,geo_country:1,geo_postal:1,geo_isp:1,device_summary:1,timezone:1,locale:1,
  viewport:1,form_version:1,turnstile_token:1,email:1,first_name:1,last_name:1,company:1};
function answerCount_(o){
  if(!o || typeof o !== 'object') return 0;
  var n = 0;
  Object.keys(o).forEach(function(k){
    if(META_KEYS[k]) return;
    var v = o[k];
    if(typeof v === 'string' ? v.trim() !== '' : (v !== '' && v != null)) n++;
  });
  return n;
}
function flushSave(extra){
  if(autosaveBlocked || regionBlocked) return;
  clearTimeout(saveTimer); clearTimeout(maxWaitTimer); saveTimer = maxWaitTimer = null;
  var body = buildPayload(extra);
  var h = hashOf(body);
  if(h === lastPostedHash && !(extra && (extra.kickoff || extra.completed))) return;
  lastPostedHash = h;
  /* The device keeps its own full copy before the network is even attempted.
     Same-device resume reads this draft; for a year it was only written in demo
     mode, so production resume silently depended on the backend lookup.
     Guard: an autosave must never SHRINK the stored draft. The Continue-as-x
     chip fires the email change, which autosaves the still-empty welcome screen
     before the gate restores anything, and that once wiped the very draft it was
     about to resume. A completion or a deliberate field clear (which carries a
     cleared list) may shrink; a spurious empty save may not. The server enqueue
     still proceeds, harmlessly, because the backend merge is non-empty-wins. */
  try{
    var isClear = body.cleared && body.cleared.length;
    var isDone = extra && (extra.completed || extra.kickoff);
    var shrinks = false;
    if(!isClear && !isDone){
      var prevRaw = store.get(LS.draft + body.submission_id);
      if(prevRaw){
        var prev = JSON.parse(prevRaw);
        if(answerCount_(prev) > answerCount_(body)) shrinks = true;
      }
    }
    if(!shrinks) store.set(LS.draft + body.submission_id, JSON.stringify(body));
  }catch(e){ try{ store.set(LS.draft + body.submission_id, JSON.stringify(body)); }catch(e2){} }
  enqueue(body);
  drainQueue();
}
function forceSave(extra){ if(document.activeElement && document.activeElement.blur) document.activeElement.blur(); flushSave(extra); }

/* saves fire on change only, never on input */
form.addEventListener('change', function(){
  collectAll();
  tryKickoff();
  scheduleSave();
});

/* flush on page hide */
function flushBeacon(){
  if(regionBlocked) return;
  /* whatever is on the screen right now is the person's answer, whether or not
     the debounce timer got to fire before the tab went away */
  try{
    var live = buildPayload();
    var h = hashOf(live);
    if(h !== lastPostedHash){
      lastPostedHash = h;
      store.set(LS.draft + live.submission_id, JSON.stringify(live));
      enqueue(live);
    }
  }catch(e){}
  var q = readQueue();
  if(!q.length || DEMO_MODE) return;
  q.forEach(function(body){ try{ navigator.sendBeacon(ENDPOINT, JSON.stringify(body)); }catch(e){} });
}
window.addEventListener('pagehide', flushBeacon);
document.addEventListener('visibilitychange', function(){ if(document.visibilityState === 'hidden') flushBeacon(); });

/* offline outbox: reconnect drains instantly, offline state is honest.
   Listeners accelerate the queue, they never gate it (captive portals lie). */
window.addEventListener('online', function(){
  retryDelay = 1000; retryCount = 0;
  setPill('Back online, syncing…');
  drainQueue();
});
window.addEventListener('offline', function(){
  setPill('Offline, answers saved on this device', 'is-issue');
});

/* ---------- kickoff + resume ---------- */
function emailIndex(){
  try{ return JSON.parse(store.get(LS.index) || '{}'); }catch(e){ return {}; }
}
function tryKickoff(force){
  var em = (document.getElementById('email').value || '').trim().toLowerCase();
  if(kickoffSent || autosaveBlocked || regionBlocked || !EMAIL_RE.test(em)) return;
  /* The email field's change event fires on blur, before the click on Start lands, so
     an unguarded kickoff posts a fresh row milliseconds before the lookup can find the
     person's existing one. The gate calls this itself once it knows there is nothing
     to resume. */
  if(!force && !(LOOKUP.done && LOOKUP.email === em)) return;
  kickoffSent = true;
  var idx = emailIndex();
  idx[em] = submissionId;
  store.set(LS.index, JSON.stringify(idx));
  flushSave({kickoff:true});
  /* form-start signal: partial fills enter the factory's intent scoring the moment
     an email exists, through the visitor-intake pipeline (suppression respected) */
  if(!DEMO_MODE){
    try {
      navigator.sendBeacon('https://acquisition.arcticgrey.org/ingest/visitor', JSON.stringify({
        secret: FORM_SECRET,
        rows: [{ source: FORM_CFG.source + '-start', email: em, url: location.href,
                 ts: new Date().toISOString(), raw_ref: 'kickoff:' + submissionId }]
      }));
    } catch(e){}
  }
}
function tryRemoteResume(emailRaw){
  if(regionBlocked) return Promise.resolve(false);
  var em = (emailRaw || '').trim().toLowerCase();
  if(!EMAIL_RE.test(em) || DEMO_MODE) return Promise.resolve(false);
  autosaveBlocked = true;
  setPill('Checking for saved progress…');
  /* a hung lookup must never leave autosave blocked: 8s abort watchdog */
  var ctl = new AbortController();
  var watchdog = setTimeout(function(){ ctl.abort(); }, 8000);
  var tok = (new URLSearchParams(location.search)).get('t') || '';
  return fetch(ENDPOINT + '?action=get&email=' + encodeURIComponent(em) +
               '&form_type=' + encodeURIComponent(FORM_TYPE) + (tok ? '&t=' + encodeURIComponent(tok) : ''), {
    credentials:'omit', redirect:'follow', cache:'no-store', mode:'cors', signal: ctl.signal
  })
  .then(function(r){ clearTimeout(watchdog); return r.json(); })
  .then(function(d){
    autosaveBlocked = false;
    if(!d.found || !d.row){ setPill('Saves as you go'); return false; }
    if(!d.row.submission_id){
      /* identity prefill only: adopting a row needs the emailed token, because an
         address alone must not buy write access to someone's open answers */
      restoreFromRow(d.row, true, true);
      setPill('Saves as you go');
      return false;
    }
    submissionId = d.row.submission_id;
    store.set(LS.sub, submissionId);
    adoptFillStart(d.row);
    kickoffSent = true;
    var idx = emailIndex(); idx[em] = submissionId; store.set(LS.index, JSON.stringify(idx));
    var n = restoreFromRow(d.row, true, true);
    if(d.row.sponsor_inputs && typeof window.__restoreSponsor === 'function') window.__restoreSponsor(d.row.sponsor_inputs);
    if(n > 0) toast('Welcome back. Your previous answers were restored.');
    setPill('All changes saved ✓');
    return true;
  })
  .catch(function(){ clearTimeout(watchdog); autosaveBlocked = false; setPill('Saves as you go'); return false; });
}
/* every draft on this device that belongs to this email, any form, newest first */
function mergeLocalDrafts(em){
  var drafts = [];
  try{
    for (var i = 0; i < localStorage.length; i++){
      var k = localStorage.key(i);
      if (k && k.indexOf('ag_td_draft_') === 0){
        try{
          var d = JSON.parse(localStorage.getItem(k) || '{}');
          if (d && String(d.email || '').toLowerCase() === em) drafts.push(d);
        }catch(e){}
      }
    }
  }catch(e){}
  drafts.sort(function(a, b){ return (b.client_ts || 0) - (a.client_ts || 0); });
  var applied = 0;
  drafts.forEach(function(d){
    adoptFillStart(d); /* the person's fill began with their earliest draft */
    if (d.submission_id === submissionId) return; /* own draft already restored */
    applied += restoreFromRow(d, true, true);
  });
  return applied;
}
function tryResume(){
  var em = (document.getElementById('email').value || '').trim().toLowerCase();
  if(!EMAIL_RE.test(em)) return false;
  var idx = emailIndex();
  /* the plain reload is the same id, and it is the case that matters most */
  var priorId = idx[em] || submissionId;
  var raw = store.get(LS.draft + priorId);
  if(!raw) return false;
  var row;
  try{ row = JSON.parse(raw); }catch(e){ return false; }
  if(row.completed) return false;
  if(row.email && String(row.email).toLowerCase() !== em) return false;
  submissionId = priorId;
  store.set(LS.sub, submissionId);
  adoptFillStart(row);
  var nLocal = restoreFromRow(row, false, true);
  /* the calculator keeps live state outside the DOM; without this, its first
     touch recomputes from house defaults and overwrites the person's figures */
  if(row.sponsor_inputs && typeof window.__restoreSponsor === 'function') window.__restoreSponsor(row.sponsor_inputs);
  if(nLocal > 0) toast('Welcome back. Your previous answers were restored.');
  return true;
}
function restoreFromRow(row, onlyEmpty, noNav){
  var restored = 0;
  Object.keys(row).forEach(function(name){
    if(name === 'consent') return; /* consent is a human action, never restored */
    var val = row[name];
    if(typeof val !== 'string') return;
    var inputs = fieldsNamed(name);
    if(!inputs.length) return;
    var first = inputs[0];
    /* a remote row can be staler than the screen: it fills gaps, never edits.
       A control that just gave up its parked name counts as empty. */
    if(onlyEmpty && !first.dataset.wasParked && !first.dataset.guessed){
      if(first.type === 'radio' || first.type === 'checkbox'){
        if(Array.prototype.some.call(inputs, function(i){ return i.checked; })) return;
      } else if(String(first.value || '').trim() !== '' && first.type !== 'range'){ return; }
    }
    delete first.dataset.wasParked;
    if(first.type === 'radio'){
      inputs.forEach(function(inp){ inp.checked = (inp.value === val); syncVisual(inp); });
    } else if(first.type === 'checkbox'){
      var parts = val.split(' | ');
      inputs.forEach(function(inp){ inp.checked = parts.indexOf(inp.value) !== -1; syncVisual(inp); });
    } else if(document.activeElement !== first){
      first.value = val;
      delete first.dataset.guessed;
    }
    /* identity and bookkeeping are not "previous answers"; claiming them as such
       tells a first-time visitor we remember a visit that never happened */
    if(['email','submission_id','current_step','form_type','status',
        'first_name','last_name','company','store_url','no_site','platform',
        'role','role_other','timezone','locale'].indexOf(name) === -1) restored++;
  });
  if(window.__syncPlatformUI) window.__syncPlatformUI();
  if(window.__syncThemePicker) window.__syncThemePicker();
  if(window.__syncRoleOther) window.__syncRoleOther();
  if(window.__syncStackBuilder) window.__syncStackBuilder();
  if(window.__syncAppMonetize) window.__syncAppMonetize();
  var fo = document.getElementById('featuresOther');
  if(fo){
    var foOn = form.querySelector('input[name="features"][value="other"]');
    fo.style.display = (foOn && foOn.checked) ? 'block' : 'none';
  }
  collectAll();
  var target = (row.current_step && STEPS.indexOf(row.current_step) !== -1 && row.current_step !== 'thanks') ? row.current_step : 'situation';
  var v = visibleSteps();
  if(v.indexOf(target) === -1) target = v[Math.min(1, v.length-1)];
  if(noNav){
    if(restored > 0) LOOKUP.targetStep = target;
  } else {
    show(target);
  }
  return restored;
}
/* email typo guard: advisory one-tap correction, never blocking */
var FREE_MAIL = ['gmail.com','yahoo.com','outlook.com','hotmail.com','icloud.com','aol.com','proton.me','protonmail.com','live.com','msn.com','me.com','mail.com','gmx.com','yandex.com'];
var DOMAIN_FIXES = {'gmial.com':'gmail.com','gmal.com':'gmail.com','gamil.com':'gmail.com','gmaill.com':'gmail.com','gmail.co':'gmail.com','gmail.con':'gmail.com','gmail.cm':'gmail.com','hotmial.com':'hotmail.com','hotmal.com':'hotmail.com','hotmail.con':'hotmail.com','yaho.com':'yahoo.com','yahooo.com':'yahoo.com','yahoo.con':'yahoo.com','outlok.com':'outlook.com','outloook.com':'outlook.com','outlook.con':'outlook.com','iclould.com':'icloud.com','icoud.com':'icloud.com','icloud.con':'icloud.com'};
function emailSuggestion(em){
  var at = em.lastIndexOf('@');
  if(at === -1) return '';
  var dom = em.slice(at+1).toLowerCase();
  if(DOMAIN_FIXES[dom]) return em.slice(0, at+1) + DOMAIN_FIXES[dom];
  if(/\.con$/.test(dom)) return em.slice(0, at+1) + dom.replace(/\.con$/, '.com');
  return '';
}
function showEmailSuggest(em){
  var s = emailSuggestion(em);
  var wrap = document.getElementById('emailSuggest');
  if(s){ document.getElementById('emailSuggestBtn').textContent = s; wrap.classList.add('is-on'); }
  else { wrap.classList.remove('is-on'); }
}
document.getElementById('emailSuggestBtn').addEventListener('click', function(){
  var input = document.getElementById('email');
  input.value = this.textContent;
  document.getElementById('emailSuggest').classList.remove('is-on');
  input.dispatchEvent(new Event('change', {bubbles:true}));
});
/* company suggestion from a business email domain, always editable. The guess
   is display only until the person accepts it: it must lose to any real record
   and it must never be saved as if they typed it, or the same wrong guess
   regenerates on every visit and buries the correction forever */
function suggestCompany(em){
  /* an applicant's work address must not name their employer for them */
  if(FORM_CFG.companyOptional) return;
  var input = document.getElementById('company');
  if(!input || (input.value || '').trim()) return;
  var at = em.lastIndexOf('@');
  if(at === -1) return;
  var dom = em.slice(at+1).toLowerCase();
  if(FREE_MAIL.indexOf(dom) !== -1) return;
  var root = dom.split('.')[0].replace(/[-_]+/g, ' ').trim();
  if(root.length < 2) return;
  input.value = root.replace(/(^|\s)[a-z]/g, function(c){ return c.toUpperCase(); });
  input.dataset.guessed = '1';
}
(function(){
  var c = document.getElementById('company');
  if(c) c.addEventListener('input', function(){ delete this.dataset.guessed; });
})();
/* never ask twice: merge every answer this email has ever given us (any entry
   point, completed or not) into empty fields only. Consent and per-submission
   meta never carry over. */
var PROFILE_SKIP = ['consent','consent_ts','submission_id','status','kickoff_at','completed_at','notified_started_at','emails_sent','last_updated','current_step','client_ts','files','asset_folder','form_type','fill_ms','fill_start_ts','spam_signals','email_attempts','user_agent','viewport','page_url','source','agent_prefill','filled_by','sponsor_estimate'];
function applyProfile(profile){
  var applied = 0;
  Object.keys(profile).forEach(function(name){
    if(PROFILE_SKIP.indexOf(name) !== -1) return;
    var val = profile[name];
    if(typeof val !== 'string' || !val) return;
    var inputs = fieldsNamed(name);
    if(!inputs.length) return;
    var first = inputs[0];
    if(first.type === 'radio'){
      if(form.querySelector('input[name="'+name+'"]:checked')) return;
      inputs.forEach(function(inp){ if(inp.value === val){ inp.checked = true; syncVisual(inp); applied++; } });
    } else if(first.type === 'checkbox'){
      var any = false; inputs.forEach(function(i){ if(i.checked) any = true; });
      if(any) return;
      var parts = val.split(' | ');
      inputs.forEach(function(inp){ if(parts.indexOf(inp.value) !== -1){ inp.checked = true; syncVisual(inp); applied++; } });
    } else if(!first.value || first.dataset.guessed){
      first.value = val; delete first.dataset.guessed; applied++;
    }
  });
  if(applied){
    if(window.__syncPlatformUI) window.__syncPlatformUI();
    if(window.__syncThemePicker) window.__syncThemePicker();
    if(window.__syncRoleOther) window.__syncRoleOther();
    collectAll();
  }
  return applied;
}
function tryProfile(em, alreadyResumed, quiet){
  if(!EMAIL_RE.test(em) || DEMO_MODE) return Promise.resolve(0);
  /* nobody should watch a spinner because a lookup hung */
  var ctl = new AbortController();
  var watchdog = setTimeout(function(){ ctl.abort(); }, 6000);
  var ptok = (new URLSearchParams(location.search)).get('t') || '';
  return fetch(ENDPOINT + '?action=profile&email=' + encodeURIComponent(em) + (ptok ? '&t=' + encodeURIComponent(ptok) : ''), {
    credentials:'omit', redirect:'follow', cache:'no-store', mode:'cors', signal: ctl.signal
  })
  .then(function(r){ clearTimeout(watchdog); return r.json(); })
  .then(function(d){
    if(!d.found || !d.profile) return 0;
    var n = applyProfile(d.profile);
    if(d.profile.sponsor_inputs && typeof window.__restoreSponsor === 'function'){
      if(window.__restoreSponsor(d.profile.sponsor_inputs)) n++;
    }
    if(n && !alreadyResumed && !quiet) toast('Welcome back. We filled in what we already know.');
    if(n) scheduleSave();
    return n;
  }).catch(function(){ clearTimeout(watchdog); return 0; });
}
document.getElementById('email').addEventListener('change', function(){
  var em = (this.value || '').trim();
  showEmailSuggest(em);
  /* a pending typo suggestion means the domain is suspect: no company guess from it */
  if(EMAIL_RE.test(em.toLowerCase()) && !emailSuggestion(em)) suggestCompany(em.toLowerCase());
  /* the lookup itself waits for Start, so nobody gets pulled backwards mid-answer */
  if(em.toLowerCase() !== LOOKUP.email) LOOKUP.done = false;
});

/* ---------- sections drawer, and inviting a colleague ----------
   Long forms punish people for wanting to check something they already answered.
   A list you can jump from removes that, and a shareable link means a second
   person can fill their half without anyone re-keying it. */
var sdDrawer = document.getElementById('sectionsDrawer');
var sdScrim = document.getElementById('sectionsScrim');
var sdReturn = null;
function sdRender(){
  var v = visibleSteps();
  var here = v.indexOf(current);
  var done = 0;
  var html = v.map(function(id, i){
    if(id === 'thanks') return '';
    var isDone = i < here, isNow = id === current;
    if(isDone) done++;
    return '<button type="button" class="sd-item' + (isDone ? ' is-done' : '') + (isNow ? ' is-current' : '') + '" data-goto="' + id + '">' +
      '<span class="sd-num" aria-hidden="true">' + (isDone ? '✓' : (i + 1)) + '</span>' +
      '<span class="sd-label">' + escHtml(stepTitle(id)) + '</span></button>';
  }).join('');
  document.getElementById('sdList').innerHTML = html;
  document.getElementById('sdCount').textContent = done + ' of ' + v.filter(function(x){ return x !== 'thanks'; }).length + ' answered';
}
function sdIsOpen(){ return sdDrawer.classList.contains('is-open'); }
function sdOpen(){
  sdRender();
  sdDrawer.hidden = false; sdScrim.hidden = false;
  void sdDrawer.offsetWidth; /* let the browser see the start position before animating */
  sdDrawer.classList.add('is-open'); sdScrim.classList.add('is-open');
  sdDrawer.setAttribute('aria-hidden', 'false');
  document.getElementById('btnSections').setAttribute('aria-expanded', 'true');
  document.body.style.overflow = 'hidden';
  sdReturn = document.activeElement;
  /* the form behind the scrim is visible but unreachable, so it should be unreachable
     to a keyboard and to a screen reader too */
  var wrap = document.querySelector('.card-wrap');
  if(wrap){ wrap.inert = true; wrap.setAttribute('aria-hidden', 'true'); }
  document.getElementById('sdClose').focus({ preventScroll: true });
}
/* Tab cycles inside the drawer rather than escaping into the hidden form behind it */
document.addEventListener('keydown', function(e){
  if(e.key !== 'Tab' || !sdIsOpen()) return;
  var f = sdDrawer.querySelectorAll('button,[href],input,select,textarea,[tabindex]:not([tabindex="-1"])');
  f = Array.prototype.filter.call(f, function(el){ return !el.disabled && el.offsetParent !== null; });
  if(!f.length) return;
  var first = f[0], last = f[f.length - 1];
  if(e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
  else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
});
function sdClose(){
  sdDrawer.classList.remove('is-open'); sdScrim.classList.remove('is-open');
  sdDrawer.setAttribute('aria-hidden', 'true');
  document.getElementById('btnSections').setAttribute('aria-expanded', 'false');
  document.body.style.overflow = '';
  var wrapC = document.querySelector('.card-wrap');
  if(wrapC){ wrapC.inert = false; wrapC.removeAttribute('aria-hidden'); }
  if(sdReturn && document.contains(sdReturn)) sdReturn.focus({ preventScroll: true });
  /* stay out of the tab order once it has finished sliding away */
  setTimeout(function(){ if(!sdIsOpen()){ sdDrawer.hidden = true; sdScrim.hidden = true; } }, 340);
}
document.getElementById('btnSections').addEventListener('click', function(){ sdIsOpen() ? sdClose() : sdOpen(); });
document.getElementById('sdClose').addEventListener('click', sdClose);
sdScrim.addEventListener('click', sdClose);
document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && sdIsOpen()) sdClose(); });
document.getElementById('sdList').addEventListener('click', function(e){
  var b = e.target.closest('[data-goto]');
  if(!b) return;
  var target = b.getAttribute('data-goto');
  /* Moving backwards is always safe. Moving forward has to clear every step in
     between, not just the one you happen to be standing on, or one click lands a
     submission with no name and no store URL. */
  var v = visibleSteps();
  var from = v.indexOf(current), to = v.indexOf(target);
  if(to > from){
    for(var i = from; i < to; i++){
      if(!validate(v[i])){ sdClose(); show(v[i]); return; }
      collectStep(v[i]);
    }
  }
  collectStep(current);
  sdClose();
  show(target);
});
document.getElementById('btnInvite').addEventListener('click', function(){
  var em = (document.getElementById('email').value || '').trim();
  var link = location.origin + location.pathname + '?form=' + encodeURIComponent(FORM_TYPE) + (em ? '&email=' + encodeURIComponent(em) : '');
  var txt = document.getElementById('inviteTxt');
  var btn = this;
  var done = function(){
    txt.textContent = 'Link copied';
    btn.classList.add('is-done');
    toast(em ? 'Link copied. Anyone who opens it with this email edits the same form.' : 'Link copied. Add your email first so a teammate lands on the same answers.');
    setTimeout(function(){ txt.textContent = 'Invite a teammate'; btn.classList.remove('is-done'); }, 3200);
  };
  if(navigator.clipboard && navigator.clipboard.writeText){
    navigator.clipboard.writeText(link).then(done, function(){ prompt('Copy this link', link); });
  } else { prompt('Copy this link', link); }
});

/* ---------- the email gate ----------
   Answers are keyed to the email address, so the moment we have one we can say
   whether there is anything to pick up. Doing that before the first question,
   rather than three steps in, is the difference between being met and being
   interrupted. */
var LOOKUP = { done:false, running:false, email:'', found:false, count:0 };
/* the device already knows the person; asking them to retype their email every
   visit is why "it never sticks" reads true even when the data is all here */
(function(){
  try{
    var last = store.get(LS.lastEmail);
    var ef = document.getElementById('email');
    if(last && ef && !ef.value){
      var chip = document.createElement('div');
      chip.className = 'hint';
      chip.style.marginTop = '8px';
      chip.innerHTML = '<button type="button" class="link-quiet" id="lastEmailUse">Continue as ' + escHtml(last) + '</button> · <button type="button" class="link-quiet" id="lastEmailClear">Not you?</button>';
      ef.parentNode.insertBefore(chip, ef.nextSibling);
      chip.querySelector('#lastEmailUse').addEventListener('click', function(){
        ef.value = last; ef.dispatchEvent(new Event('change', {bubbles:true})); chip.remove();
        var go = document.getElementById('gateStart') || document.querySelector('[data-step="welcome"] .btn-primary');
        if(go) go.focus();
      });
      chip.querySelector('#lastEmailClear').addEventListener('click', function(){
        try{ store.remove ? store.remove(LS.lastEmail) : localStorage.removeItem(LS.lastEmail); }catch(e){}
        chip.remove(); ef.focus();
      });
    }
  }catch(e){}
})();
function lookupEmail(raw, localAlready){
  var em = (raw || '').trim().toLowerCase();
  /* written here, at the gate, so the device remembers an address the person
     typed or pressed Start on, never one a shared link happened to carry */
  if(EMAIL_RE.test(em)) try{ store.set(LS.lastEmail, em); }catch(e){}
  if(LOOKUP.running) return LOOKUP.running;
  if(LOOKUP.done && LOOKUP.email === em) return Promise.resolve(LOOKUP);
  LOOKUP.email = em;
  var local = (localAlready !== undefined) ? localAlready : tryResume();
  var crossForm = mergeLocalDrafts(em);
  var started = Date.now();
  LOOKUP.running = (local ? Promise.resolve(true) : tryRemoteResume(em))
    .then(function(found){
      LOOKUP.found = !!found;
      if(!found) tryKickoff(true);
      return tryProfile(em, true, true);
    })
    .then(function(n){
      LOOKUP.count = (n || 0) + crossForm;
      /* a check that blinks past reads as no check at all */
      var wait = Math.max(0, 900 - (Date.now() - started));
      return new Promise(function(res){ setTimeout(res, wait); });
    })
    .then(function(){
      LOOKUP.done = true; LOOKUP.running = false;
      return LOOKUP;
    })
    .catch(function(){ LOOKUP.done = true; LOOKUP.running = false; return LOOKUP; });
  return LOOKUP.running;
}
function gateStart(btn, localAlready){
  var em = (document.getElementById('email').value || '').trim();
  var status = document.getElementById('gateStatus');
  btn.classList.add('is-busy'); btn.disabled = true;
  status.hidden = false;
  status.className = 'gate-status is-working';
  status.innerHTML = '<span class="gate-dots"><i></i><i></i><i></i></span> Searching our records for anything you have already told us…';
  live.textContent = 'Searching our records.';
  var slow = setTimeout(function(){
    if(status.classList.contains('is-working'))
      status.innerHTML = '<span class="gate-dots"><i></i><i></i><i></i></span> Still looking. This check only happens once, and it is worth it.';
  }, 2600);
  return lookupEmail(em, localAlready).then(function(r){
    clearTimeout(slow);
    btn.classList.remove('is-busy'); btn.disabled = false;
    var restored = r.found || r.count > 0;
    status.className = 'gate-status ' + (restored ? 'is-found' : 'is-fresh');
    if(restored){
      status.innerHTML = '<b>Found you.</b> We filled in what you have already told us, so you only answer what is new. Opening your form…';
      live.textContent = 'We found your details and filled them in. Opening your form.';
    } else {
      status.innerHTML = '<b>Welcome.</b> Nothing on file for this address, so we are starting you fresh. Filled in a form with us before? Try the email you used then, and your answers come with it.';
      live.textContent = 'Nothing on file. Starting fresh.';
    }
    return r;
  });
}

/* URL normalization on blur: schemeless input gains https, stray spaces go */
['storeUrl','assetLink'].forEach(function(fid){
  var el = document.getElementById(fid);
  el.addEventListener('blur', function(){
    var v = (this.value || '').trim().replace(/\s+/g, '');
    if(v && !/^https?:\/\//i.test(v) && /^[\w-]+(\.[\w-]+)+/.test(v)) v = 'https://' + v;
    if(v !== this.value){ this.value = v; collectAll(); scheduleSave(); }
  });
});

/* ---------- toast ---------- */
var toastTimer = null;
function toast(msg){
  toastEl.textContent = msg;
  toastEl.classList.add('is-on');
  clearTimeout(toastTimer);
  toastTimer = setTimeout(function(){ toastEl.classList.remove('is-on'); }, 4200);
}

/* ---------- visual sync for custom controls ---------- */
function syncVisual(input){
  var wrap = input.closest('.radio-card, .chip, .toggle-card, .style-tile, .consent-row');
  if(!wrap) return;
  var cls = wrap.classList.contains('toggle-card') ? 'is-on'
          : wrap.classList.contains('consent-row') ? 'is-on'
          : 'is-selected';
  if(input.type === 'radio'){
    form.querySelectorAll('[name="'+input.name+'"]').forEach(function(other){
      var ow = other.closest('.radio-card, .chip, .style-tile');
      if(ow) ow.classList.toggle('is-selected', other.checked);
    });
  } else {
    wrap.classList.toggle(cls, input.checked);
  }
}
form.addEventListener('change', function(e){
  var input = e.target;
  if(input.type !== 'radio' && input.type !== 'checkbox') return;
  syncVisual(input);
  var wrap = input.closest('.radio-card, .chip, .style-tile');
  if(wrap && input.checked){
    wrap.classList.remove('is-pulsing'); void wrap.offsetWidth; wrap.classList.add('is-pulsing');
    setTimeout(function(){ wrap.classList.remove('is-pulsing'); }, 600);
  }
});

/* situation controls no-site toggle visibility */
form.addEventListener('change', function(e){
  if(e.target.name === 'situation'){
    var show = (e.target.value === 'new_store' || e.target.value === 'exploring');
    document.getElementById('noSiteToggle').style.display = show ? 'flex' : 'none';
    document.getElementById('assetsLede').textContent = show
      ? 'Your logo matters most here, plus anything else with your brand on it. Brand guide, product shots, old design files.'
      : 'Logo, brand guide, product shots, a CSV of products, old design files. One drop zone for everything, all optional.';
  }
  if(e.target.name === 'features'){
    var otherOn = !!form.querySelector('input[name="features"][value="other"]:checked');
    document.getElementById('featuresOther').style.display = otherOn ? 'block' : 'none';
  }
  if(e.target.name === 'role') window.__syncRoleOther();
});
window.__syncRoleOther = function(){
  var checked = form.querySelector('input[name="role"]:checked');
  document.getElementById('roleOtherWrap').style.display = (checked && checked.value === 'other') ? 'block' : 'none';
};

/* ---------- design gallery: real storefront designs, pick up to 3 ----------
   Catalog served by our worker; screenshots stay on the source CDN. Clicking
   a card only ever selects it. Picks travel as "Name :: URL" in theme_picks. */
var THEMES_URL = 'https://test-drive.arcticgrey.org/themes.json?v=4';
var TP_MAX = 3;
var TP = { data:null, picks:[], shown:24, q:'', ind:-1, failed:false };
var tpGrid = document.getElementById('tpGrid');
var tpCount = document.getElementById('tpCount');
var tpMore = document.getElementById('tpMore');
var tpTray = document.getElementById('tpTray');
var tpTrayItems = document.getElementById('tpTrayItems');
var tpClear = document.getElementById('tpClear');
var TP_CHECK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

function tpImg(file, w){ return 'https://cdn.shopify.com/theme-store/' + file + '?width=' + w; }
function tpFiltered(){
  if(!TP.data) return [];
  var q = TP.q.toLowerCase();
  return TP.data.themes.filter(function(t){
    if(TP.ind !== -1 && t.i.indexOf(TP.ind) === -1) return false;
    if(q && t.n.toLowerCase().indexOf(q) === -1) return false;
    return true;
  });
}
function tpIsPicked(u){ return TP.picks.some(function(p){ return p.u === u; }); }
function tpWriteField(){
  document.getElementById('themePicks').value = TP.picks.map(function(p){
    return p.n + ' :: https://themes.shopify.com' + p.u;
  }).join(' | ');
}
function tpCardHtml(t){
  var picked = tpIsPicked(t.u);
  return '<button type="button" class="tp-card' + (picked ? ' is-selected' : '') + '" data-url="' + t.u + '" data-name="' + escHtml(t.n) + '" data-img="' + t.img + '" aria-pressed="' + (picked ? 'true' : 'false') + '">' +
    '<span class="tp-thumb"><img loading="lazy" decoding="async" alt="' + escHtml(t.n) + '" src="' + tpImg(t.img, 560) + '" srcset="' + tpImg(t.img, 560) + ' 1x, ' + tpImg(t.img, 1120) + '&quality=80 2x">' +
    '<span class="tp-expand" role="button" tabindex="0" data-preview="' + t.u + '" aria-label="Preview ' + escHtml(t.n) + ' larger">⤢</span>' +
    '<span class="tp-badge">' + TP_CHECK + '</span></span>' +
    '<span class="tp-name">' + escHtml(t.n) + '</span></button>';
}
function tpRenderTray(){
  if(!TP.picks.length){ tpTray.classList.remove('is-on'); tpTrayItems.innerHTML = ''; tpClear.hidden = true; return; }
  tpTrayItems.innerHTML = TP.picks.map(function(p){
    return '<span class="tp-mini">' +
      '<button type="button" class="tp-mini-open" data-preview="' + p.u + '" aria-label="Preview ' + escHtml(p.n) + ' larger">' +
      '<img alt="" src="' + tpImg(p.img, 120) + '"><span class="tp-mini-name">' + escHtml(p.n) + '</span></button>' +
      '<button type="button" class="tp-mini-remove" data-remove="' + p.u + '" aria-label="Remove ' + escHtml(p.n) + '">✕</button></span>';
  }).join('');
  tpTray.classList.add('is-on');
  tpClear.hidden = false;
}
function tpRenderCount(){
  if(!TP.data){ tpCount.textContent = TP.failed ? 'Designs are taking a moment. Continue and come back any time.' : 'Loading designs…'; return; }
  var total = tpFiltered().length;
  var showing = Math.min(TP.shown, total);
  tpCount.textContent = 'Showing ' + showing + ' of ' + total + ' designs · ' + TP.picks.length + ' of ' + TP_MAX + ' selected';
}
function tpRender(){
  if(!TP.data){
    tpGrid.innerHTML = TP.failed ? '' : new Array(4).join('.').split('.').map(function(){ return '<div class="tp-skel"></div>'; }).join('');
    tpRenderCount();
    return;
  }
  var list = tpFiltered();
  if(!list.length){
    tpGrid.innerHTML = '<div class="tp-empty">No designs match that. <button type="button" class="tp-clear" id="tpReset">Reset filters</button></div>';
    tpMore.hidden = true;
    tpRenderCount();
    return;
  }
  tpGrid.innerHTML = list.slice(0, TP.shown).map(tpCardHtml).join('');
  tpMore.hidden = TP.shown >= list.length;
  tpRenderCount();
}
function tpChipsRender(){
  var chips = ['<button type="button" class="tp-chip' + (TP.ind === -1 ? ' is-on' : '') + '" data-ind="-1">All</button>'];
  TP.data.industry_labels.forEach(function(lbl, idx){
    chips.push('<button type="button" class="tp-chip' + (TP.ind === idx ? ' is-on' : '') + '" data-ind="' + idx + '">' + escHtml(lbl) + '</button>');
  });
  document.getElementById('tpChips').innerHTML = chips.join('');
}
function tpSyncCards(){
  document.querySelectorAll('#tpGrid .tp-card, #tpRecGrid .tp-card').forEach(function(c){
    var on = tpIsPicked(c.getAttribute('data-url'));
    c.classList.toggle('is-selected', on);
    c.setAttribute('aria-pressed', on ? 'true' : 'false');
  });
}
function tpAfterChange(){
  tpWriteField();
  tpRenderTray();
  tpRenderCount();
  if(typeof tpWriteMeta === 'function') tpWriteMeta();
  collectAll();
  scheduleSave();
}
function tpToggle(u, n, img, card, src, rank){
  if(tpIsPicked(u)){
    TP.picks = TP.picks.filter(function(p){ return p.u !== u; });
    live.textContent = n + ' removed. ' + TP.picks.length + ' of ' + TP_MAX + ' selected.';
  } else {
    if(TP.picks.length >= TP_MAX){ toast('Three picks max. Remove one to swap it out.'); return; }
    TP.picks.push({ n: n, u: u, img: img, src: src || 'browse', rank: rank || 0 });
    live.textContent = n + ' selected. ' + TP.picks.length + ' of ' + TP_MAX + ' selected.';
    if(card && !PREFERS_REDUCED){
      card.classList.remove('is-popping'); void card.offsetWidth; card.classList.add('is-popping');
      setTimeout(function(){ card.classList.remove('is-popping'); }, 440);
    }
  }
  tpSyncCards();
  tpAfterChange();
}
function tpHydrate(){
  var raw = (document.getElementById('themePicks').value || '').trim();
  TP.picks = [];
  if(raw){
    raw.split(' | ').forEach(function(part){
      var bits = part.split(' :: ');
      if(bits.length !== 2) return;
      var u = bits[1].replace('https://themes.shopify.com', '');
      var img = '';
      if(TP.data){
        var hit = TP.data.themes.filter(function(t){ return t.u === u; })[0];
        if(hit) img = hit.img;
      }
      TP.picks.push({ n: bits[0], u: u, img: img });
    });
  }
  if(TP.data){ tpSyncCards(); tpRenderTray(); tpRenderCount(); }
}
window.__syncThemePicker = tpHydrate;

/* preview: see a design large without losing your place in the grid */
var tpLb = document.getElementById('tpLb'), tpLbImg = document.getElementById('tpLbImg'),
    tpLbName = document.getElementById('tpLbName'), tpLbToggle = document.getElementById('tpLbToggle'),
    tpLbClose = document.getElementById('tpLbClose');
var tpLbUrl = '', tpLbReturn = null;
function tpFind(u){
  if(TP.data){ var hit = TP.data.themes.filter(function(t){ return t.u === u; })[0]; if(hit) return hit; }
  var pick = TP.picks.filter(function(p){ return p.u === u; })[0];
  return pick ? { n: pick.n, u: pick.u, img: pick.img } : null;
}
function tpLbSyncToggle(){
  tpLbToggle.textContent = tpIsPicked(tpLbUrl) ? 'Remove this pick' : 'Select this design';
}
function tpOpenPreview(u, returnEl){
  var t = tpFind(u);
  if(!t) return;
  tpLbUrl = u; tpLbReturn = returnEl || null;
  tpLbImg.src = tpImg(t.img, 1280);
  tpLbImg.alt = t.n;
  tpLbName.textContent = t.n;
  tpLbSyncToggle();
  tpLb.classList.add('is-on');
  document.body.style.overflow = 'hidden';
  tpLbClose.focus({ preventScroll: true });
}
function tpClosePreview(){
  tpLb.classList.remove('is-on');
  document.body.style.overflow = '';
  if(tpLbReturn && document.contains(tpLbReturn)) tpLbReturn.focus({ preventScroll: true });
  tpLbReturn = null;
}
tpLbClose.addEventListener('click', tpClosePreview);
tpLb.addEventListener('click', function(e){ if(e.target === tpLb) tpClosePreview(); });
document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && tpLb.classList.contains('is-on')) tpClosePreview(); });
tpLbToggle.addEventListener('click', function(){
  var t = tpFind(tpLbUrl);
  if(!t) return;
  var rec = tpRecGrid.querySelector('.tp-card[data-url="' + tpLbUrl + '"]');
  var card = rec || tpGrid.querySelector('.tp-card[data-url="' + tpLbUrl + '"]');
  tpToggle(t.u, t.n, t.img, card, rec ? 'ai' : 'browse', rec ? parseInt(rec.getAttribute('data-rank'), 10) : 0);
  tpLbSyncToggle();
});

tpGrid.addEventListener('click', function(e){
  if(e.target.id === 'tpReset'){ TP.q = ''; TP.ind = -1; TP.shown = 24; tpChipsRender(); tpRender(); return; }
  var exp = e.target.closest('[data-preview]');
  if(exp){ e.stopPropagation(); tpOpenPreview(exp.getAttribute('data-preview'), exp); return; }
  var card = e.target.closest('.tp-card');
  if(!card) return;
  tpToggle(card.getAttribute('data-url'), card.getAttribute('data-name'), card.getAttribute('data-img'), card);
});
tpGrid.addEventListener('keydown', function(e){
  var exp = e.target.closest('.tp-expand');
  if(exp && (e.key === 'Enter' || e.key === ' ')){ e.preventDefault(); e.stopPropagation(); tpOpenPreview(exp.getAttribute('data-preview'), exp); }
});
tpTrayItems.addEventListener('click', function(e){
  var open = e.target.closest('[data-preview]');
  if(open){ tpOpenPreview(open.getAttribute('data-preview'), open); return; }
  var btn = e.target.closest('[data-remove]');
  if(!btn) return;
  var u = btn.getAttribute('data-remove');
  var pick = TP.picks.filter(function(p){ return p.u === u; })[0];
  tpToggle(u, pick ? pick.n : 'Design', pick ? pick.img : '', null);
});
tpClear.addEventListener('click', function(){
  TP.picks = [];
  live.textContent = 'All picks cleared.';
  tpSyncCards();
  tpAfterChange();
});
document.getElementById('tpChips').addEventListener('click', function(e){
  var chip = e.target.closest('.tp-chip');
  if(!chip) return;
  TP.ind = parseInt(chip.getAttribute('data-ind'), 10);
  TP.shown = 24;
  tpChipsRender();
  tpRender();
  tpGrid.scrollIntoView({ block: 'start', behavior: PREFERS_REDUCED ? 'auto' : 'smooth' });
});
tpMore.addEventListener('click', function(){
  var before = tpGrid.querySelectorAll('.tp-card').length;
  TP.shown += 24;
  tpRender();
  var cards = tpGrid.querySelectorAll('.tp-card');
  if(cards[before]) cards[before].focus({ preventScroll: true });
});

/* ---------- matching a written description to real storefronts ----------
   Two passes. The local pass reads the description against measured visual
   axes and the themes' own copy, and lands in a few milliseconds with no
   network. The semantic pass runs at the edge and refines the order when it
   arrives. Either one alone still produces a usable list. */
var AX_KEYS = ['lum','sat','airy','dark','warm','hfoc','edge','ctr','colr'];
var STOP = {};
'a an and or the of for with to in on at is are it its my our we you your i like love want need something looks look feel feels vibe style design site store shop brand kind sort very really more most just about that this those these be by as from into over than then them they not no nothing never without avoid dont isnt anti too so bit touch hint some little kinda'.split(' ').forEach(function(w){ STOP[w] = 1; });
var LEXMAP = null;
var MATCH = { on:false, prompt:'', results:[], why:'', source:'', engine:'local', t:0 };
var tpRecs = document.getElementById('tpRecs');
var tpRecGrid = document.getElementById('tpRecGrid');
var tpRecNote = document.getElementById('tpRecNote');
var aiInput = document.getElementById('designPrompt');
var aiGo = document.getElementById('aiGo');

var AI_STARTERS = ['Minimal and airy', 'Dark and dramatic', 'Warm and earthy', 'Bold and colorful', 'Editorial, big typography', 'Quiet luxury'];

function tpNorm(s){ return String(s || '').toLowerCase().replace(/[^a-z0-9\s'-]/g, ' ').replace(/\s+/g, ' ').trim(); }
function lexBuild(){
  LEXMAP = {};
  (TP.data.lex || []).forEach(function(e){
    [e.t].concat(e.alias || []).forEach(function(f){ if(f && !LEXMAP[f]) LEXMAP[f] = e; });
  });
}
/* Merchants say what they do not want as often as what they want, and they name
   their product before they name a colour. Both have to survive the read. */
var NEGATORS = {}, SOFTENERS = {};
'not no nothing never without avoid dont isnt anti less minus skip hate'.split(' ').forEach(function(w){ NEGATORS[w] = 1; });
'bit touch hint pop pops accent accents splash some slight subtle little tiny'.split(' ').forEach(function(w){ SOFTENERS[w] = 1; });
function tpIntent(text){
  var toks = tpNorm(text).split(' ').filter(Boolean);
  if(!toks.length) return null;
  var i, k, j;
  // a negator reaches across the next few words, so "not loud or discounty" covers both
  var negScope = new Array(toks.length), softScope = new Array(toks.length);
  for(i = 0; i < toks.length; i++){
    if(NEGATORS[toks[i]]) for(k = i + 1; k <= Math.min(toks.length - 1, i + 4); k++) negScope[k] = 1;
    // "a bit of sage" means less sage; "a bit like a spa" does not mean less spa
    if(SOFTENERS[toks[i]] && toks[i + 1] !== 'like')
      for(k = i + 1; k <= Math.min(toks.length - 1, i + 3); k++) softScope[k] = 1;
  }
  var used = new Array(toks.length), matched = [];
  for(var n = 3; n >= 1; n--){
    for(i = 0; i + n <= toks.length; i++){
      var clash = false;
      for(k = i; k < i + n; k++){ if(used[k]) clash = true; }
      if(clash) continue;
      var g = toks.slice(i, i + n).join(' ');
      var e = LEXMAP[g] || LEXMAP[g.replace(/s$/, '')] || LEXMAP[g.replace(/ies$/, 'y')];
      if(e){
        matched.push({ e: e, neg: !!negScope[i], soft: !!softScope[i] });
        for(j = i; j < i + n; j++) used[j] = 1;
      }
    }
  }
  var ax = {}, axw = {}, avoid = {}, avoidw = {}, tags = {}, banTags = {}, inds = {}, labels = [], notLabels = [], free = [];
  matched.forEach(function(m){
    var e = m.e, scale = m.soft ? 0.3 : 1;
    if(m.neg){
      notLabels.push(e.t);
      Object.keys(e.ax || {}).forEach(function(key){
        if(AX_KEYS.indexOf(key) === -1) return;
        avoid[key] = (avoid[key] || 0) + e.ax[key][0] * e.ax[key][1];
        avoidw[key] = (avoidw[key] || 0) + e.ax[key][1];
      });
      (e.tags || []).forEach(function(t){ banTags[t] = 1; });
      return;
    }
    labels.push(e.t);
    Object.keys(e.ax || {}).forEach(function(key){
      if(AX_KEYS.indexOf(key) === -1) return;
      ax[key] = (ax[key] || 0) + e.ax[key][0] * e.ax[key][1] * scale;
      axw[key] = (axw[key] || 0) + e.ax[key][1] * scale;
    });
    (e.tags || []).forEach(function(t){ tags[t] = 1; });
    (e.ind || []).forEach(function(t){ inds[t] = 1; });
  });
  Object.keys(ax).forEach(function(key){ ax[key] = ax[key] / axw[key]; });
  Object.keys(avoid).forEach(function(key){ avoid[key] = avoid[key] / avoidw[key]; });
  var nouns = TP.data.nounmap || {}, indLabels = TP.data.industry_labels || [], namedProduct = false;
  toks.forEach(function(t, idx){
    if(used[idx] || STOP[t] || t.length < 3) return;
    var ind = nouns[t];
    if(ind === undefined) ind = nouns[t.replace(/s$/, '')];
    if(ind !== undefined && !negScope[idx]){
      inds[indLabels[ind]] = 1;
      namedProduct = true;
      labels.push(t);
      tags[t] = 1;
      return;
    }
    free.push(t);
    if(!negScope[idx]) tags[t] = 1;
  });
  if(!matched.length && !free.length) return null;
  var CALM = ['calm','minimal','simple','quiet luxury','understated','refined','serene','clean','airy','elegant','timeless','trustworthy','discounty','roomy'];
  var wantsQuiet = notLabels.length ? 1 : 0;
  labels.forEach(function(l){ if(CALM.indexOf(l) !== -1) wantsQuiet = 1; });
  // ruling out the hard sell by name has to be able to beat the industry bonus
  var SELL = ['discounty','loud','flashy'], ruledOutSell = 0;
  notLabels.forEach(function(l){ if(SELL.indexOf(l) !== -1) ruledOutSell = 1; });
  return { ax: ax, axw: axw, avoid: avoid, avoidw: avoidw, tags: tags, banTags: banTags, inds: inds, labels: labels, notLabels: notLabels, free: free, wantsQuiet: wantsQuiet, namedProduct: namedProduct, ruledOutSell: ruledOutSell };
}
function tpAxVal(t, key){
  var m = TP.data.axmeta[key];
  return m[0] + (t.a[AX_KEYS.indexOf(key)] / 255) * (m[1] - m[0]);
}
function tpLocalScore(intent){
  var d = TP.data, terms = d.terms || [], idf = d.idf || [];
  var termIdx = {}, banIdx = {};
  Object.keys(intent.tags).forEach(function(t){
    var i = terms.indexOf(t);
    if(i !== -1) termIdx[i] = 1;
  });
  Object.keys(intent.banTags).forEach(function(t){
    var i = terms.indexOf(t);
    if(i !== -1) banIdx[i] = 1;
  });
  var wantAx = Object.keys(intent.ax), avoidAx = Object.keys(intent.avoid);
  var indKeys = Object.keys(intent.inds), indIdx = {};
  // one or two industries is a real constraint; five is colour words guessing
  var anyInd = indKeys.length > 0 && indKeys.length <= 3;
  if(anyInd) indKeys.forEach(function(lbl){
    var i = d.industry_labels.indexOf(lbl);
    if(i !== -1) indIdx[i] = 1;
  });
  var out = [];
  for(var i = 0; i < d.themes.length; i++){
    var t = d.themes[i], sc = 0, a, key, w, m, span;
    if(wantAx.length){
      var got = 0, tot = 0;
      for(a = 0; a < wantAx.length; a++){
        key = wantAx[a]; w = intent.axw[key]; m = d.axmeta[key]; span = (m[1] - m[0]) || 1;
        got += Math.max(0, 1 - (Math.abs(tpAxVal(t, key) - intent.ax[key]) / span) * 2.2) * w;
        tot += w;
      }
      sc += (got / (tot || 1)) * 0.58;
    }
    // what they ruled out costs the theme, rather than quietly attracting it
    if(avoidAx.length){
      var bad = 0, btot = 0;
      for(a = 0; a < avoidAx.length; a++){
        key = avoidAx[a]; w = intent.avoidw[key]; m = d.axmeta[key]; span = (m[1] - m[0]) || 1;
        bad += Math.max(0, 1 - (Math.abs(tpAxVal(t, key) - intent.avoid[key]) / span) * 2.2) * w;
        btot += w;
      }
      sc -= (bad / (btot || 1)) * 0.45;
    }
    var doc = d.docs[t.h] || [], lex = 0, ban = 0;
    for(var p = 0; p < doc.length; p += 2){
      if(termIdx[doc[p]]) lex += (doc[p + 1] / 15) * (idf[doc[p]] || 1);
      if(banIdx[doc[p]]) ban += (doc[p + 1] / 15) * (idf[doc[p]] || 1);
    }
    if(lex) sc += Math.min(1, lex / 4) * (wantAx.length ? 0.26 : 0.72);
    if(ban) sc -= Math.min(1, ban / 4) * 0.30;
    // naming the product is a hard constraint, not a nudge
    if(anyInd) sc += t.i.some(function(x){ return indIdx[x]; }) ? 0.34 : (intent.namedProduct ? -0.16 : 0);
    // the feature list is the only place a hard sell shows up
    if(intent.wantsQuiet) sc -= ((d.urg || [])[t.h] || 0) * (intent.ruledOutSell ? 0.52 : 0.26);
    out.push({ t: t, i: i, s: sc });
  }
  return out;
}
/* one preset per theme family, so eight results are eight different designs */
function tpTopUnique(scored, n){
  scored.sort(function(a, b){ return b.s - a.s; });
  var seen = {}, out = [];
  for(var i = 0; i < scored.length && out.length < n; i++){
    var h = scored[i].t.h;
    if(seen[h]) continue;
    if(scored[i].s <= -900) break;
    seen[h] = 1;
    out.push(scored[i]);
  }
  return out;
}
function tpRecCardHtml(r, rank){
  var t = r.t, picked = tpIsPicked(t.u);
  return '<button type="button" class="tp-card is-rec' + (picked ? ' is-selected' : '') + '" data-url="' + t.u + '" data-name="' + escHtml(t.n) + '" data-img="' + t.img + '" data-rank="' + rank + '" aria-pressed="' + (picked ? 'true' : 'false') + '">' +
    '<span class="tp-thumb"><img loading="lazy" decoding="async" alt="' + escHtml(t.n) + '" src="' + tpImg(t.img, 560) + '" srcset="' + tpImg(t.img, 560) + ' 1x, ' + tpImg(t.img, 1120) + '&quality=80 2x">' +
    '<span class="tp-rank">' + rank + '</span>' +
    '<span class="tp-expand" role="button" tabindex="0" data-preview="' + t.u + '" aria-label="Preview ' + escHtml(t.n) + ' larger">⤢</span>' +
    '<span class="tp-badge">' + TP_CHECK + '</span></span>' +
    '<span class="tp-name">' + escHtml(t.n) + '</span></button>';
}
function tpRenderRecs(){
  if(!MATCH.on || !MATCH.results.length){ tpRecs.hidden = true; return; }
  tpRecs.hidden = false;
  tpRecGrid.innerHTML = MATCH.results.map(function(r, i){ return tpRecCardHtml(r, i + 1); }).join('');
  tpRecNote.textContent = MATCH.why;
}
function tpRunMatch(){
  if(!TP.data || !LEXMAP) return;
  var text = (aiInput.value || '').trim();
  if(!text){
    MATCH.on = false; MATCH.results = []; MATCH.prompt = '';
    tpRecs.hidden = true;
    tpWriteMeta();
    return;
  }
  var t0 = (window.performance && performance.now) ? performance.now() : 0;
  var intent = tpIntent(text);
  if(!intent){ MATCH.on = false; tpRecs.hidden = true; return; }
  var top = tpTopUnique(tpLocalScore(intent), 8);
  if(!top.length){
    MATCH.on = true; MATCH.results = []; tpRecs.hidden = false;
    tpRecGrid.innerHTML = '<div class="tp-empty">Nothing matched that yet. Try describing colors, mood, or spacing, or browse below.</div>';
    tpRecNote.textContent = '';
    return;
  }
  var ms = t0 ? Math.max(1, Math.round(((window.performance && performance.now) ? performance.now() : 0) - t0)) : 0;
  var reasons = intent.labels.slice(0, 5).filter(Boolean);
  var avoided = (intent.notLabels || []).slice(0, 3);
  MATCH.on = true;
  MATCH.prompt = text;
  MATCH.results = top;
  MATCH.engine = 'local';
  MATCH.t = ms;
  MATCH.why = 'Top ' + top.length + ' of ' + TP.data.themes.length + ' designs' +
    (reasons.length ? ', matched on ' + reasons.join(', ') : '') +
    (avoided.length ? ', avoiding ' + avoided.join(', ') : '');
  tpRenderRecs();
  tpWriteMeta();
  live.textContent = top.length + ' designs matched to your description.';
  tpRecs.scrollIntoView({ block: 'nearest', behavior: PREFERS_REDUCED ? 'auto' : 'smooth' });
  tpSemantic(text, intent);
}
/* the edge refines the order; a failure here is invisible because local already ran */
var tpSemTimer = null, tpSemSeq = 0;
function tpSemantic(text, intent){
  var seq = ++tpSemSeq;
  clearTimeout(tpSemTimer);
  tpSemTimer = setTimeout(function(){
    var ctl = ('AbortController' in window) ? new AbortController() : null;
    var killer = setTimeout(function(){ if(ctl) ctl.abort(); }, 4000);
    fetch('https://test-drive.arcticgrey.org/match', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ prompt: text }),
      signal: ctl ? ctl.signal : undefined
    }).then(function(r){ return r.ok ? r.json() : null; }).then(function(d){
      clearTimeout(killer);
      if(!d || !d.ok || seq !== tpSemSeq || !d.themes || !d.themes.length) return;
      var byHandle = {};
      d.themes.forEach(function(h, i){ byHandle[h] = d.themes.length - i; });
      var scored = tpLocalScore(intent);
      scored.forEach(function(r){
        var handle = TP.data.handles[r.t.h];
        if(byHandle[handle]) r.s += (byHandle[handle] / d.themes.length) * 0.32;
      });
      var top = tpTopUnique(scored, 8);
      if(!top.length) return;
      MATCH.results = top;
      MATCH.engine = 'semantic';
      var avoided = (intent.notLabels || []).slice(0, 3);
      // the edge does not parse negation, so never echo back a word they ruled out
      var reasons = ((d.reasons && d.reasons.length) ? d.reasons : intent.labels)
        .filter(function(x){ return avoided.indexOf(x) === -1; }).slice(0, 5);
      MATCH.why = 'Top ' + top.length + ' of ' + TP.data.themes.length + ' designs, matched on ' + reasons.slice(0, 5).join(', ') +
        (avoided.length ? ', avoiding ' + avoided.join(', ') : '');
      tpRenderRecs();
      tpWriteMeta();
    }).catch(function(){ clearTimeout(killer); });
  }, 60);
}
/* what the design team and the next round of tuning need to know */
function tpWriteMeta(){
  var picks = TP.picks.map(function(p){
    return p.n + '=' + (p.src || 'browse') + (p.rank ? '#' + p.rank : '');
  }).join(', ');
  var bits = [
    'engine:' + (MATCH.on ? MATCH.engine : 'none'),
    'prompt_source:' + (PROMPT_SOURCE || 'none'),
    'shown:' + (MATCH.results || []).length,
    'picks:' + (picks || 'none')
  ];
  if(MATCH.t) bits.push('local_ms:' + MATCH.t);
  document.getElementById('designPromptMeta').value = bits.join(' | ');
}
var PROMPT_SOURCE = '';
/* reading the store they already run turns an empty box into something to edit */
var BRAND = { tried: false, text: '' };
function brandDraft(){
  if(BRAND.tried) return;
  var el = document.getElementById('storeUrl');
  var u = el ? (el.value || '').trim() : '';
  if(!u || u.length < 5 || u.indexOf('.') === -1) return;
  var noSite = document.querySelector('input[name="no_site"]:checked');
  if(noSite && noSite.value === 'yes') return;
  BRAND.tried = true;
  var flag = document.getElementById('aiDrafting');
  if(flag) flag.hidden = false;
  var ctl = ('AbortController' in window) ? new AbortController() : null;
  var killer = setTimeout(function(){ if(ctl) ctl.abort(); }, 12000);
  fetch('https://test-drive.arcticgrey.org/brandprompt?url=' + encodeURIComponent(u), { signal: ctl ? ctl.signal : undefined })
    .then(function(r){ return r.ok ? r.json() : null; })
    .then(function(d){
      clearTimeout(killer);
      if(flag) flag.hidden = true;
      if(!d || !d.ok || !d.prompt) return;
      BRAND.text = d.prompt;
      applyBrandDraft();
    })
    .catch(function(){ clearTimeout(killer); if(flag) flag.hidden = true; });
}
function applyBrandDraft(){
  if(!BRAND.text) return;
  var ta = document.getElementById('designPrompt');
  if(!ta || ta.value.trim()) return;
  ta.value = BRAND.text;
  ta.classList.add('is-drafted');
  PROMPT_SOURCE = 'suggested';
  live.textContent = 'We drafted a description from your site. Edit it or replace it.';
  if(TP.data && LEXMAP) tpRunMatch();
  collectAll();
  scheduleSave();
}
(function wireBrand(){
  var el = document.getElementById('storeUrl');
  if(el) el.addEventListener('blur', function(){ setTimeout(brandDraft, 60); });
})();
aiGo.addEventListener('click', function(){
  if(PROMPT_SOURCE === 'suggested' && aiInput.value.trim()) PROMPT_SOURCE = 'suggested-kept';
  tpRunMatch();
  collectAll();
  scheduleSave();
});
aiInput.addEventListener('input', function(){
  aiInput.classList.remove('is-drafted');
  if(PROMPT_SOURCE === 'suggested' || PROMPT_SOURCE === 'suggested-kept') PROMPT_SOURCE = 'suggested-edited';
  else if(!PROMPT_SOURCE) PROMPT_SOURCE = 'written';
});
aiInput.addEventListener('keydown', function(e){
  if((e.metaKey || e.ctrlKey) && e.key === 'Enter'){ e.preventDefault(); aiGo.click(); }
});
document.getElementById('aiChips').addEventListener('click', function(e){
  var chip = e.target.closest('.ai-chip');
  if(!chip) return;
  var add = chip.getAttribute('data-add');
  var cur = aiInput.value.trim();
  aiInput.value = cur ? (cur.replace(/[.,\s]+$/, '') + ', ' + add.toLowerCase()) : add;
  aiInput.classList.remove('is-drafted');
  if(!PROMPT_SOURCE) PROMPT_SOURCE = 'starter';
  aiInput.focus();
  tpRunMatch();
});
document.getElementById('tpRecsClear').addEventListener('click', function(){
  aiInput.value = '';
  MATCH.on = false; MATCH.results = [];
  tpRecs.hidden = true;
  aiInput.focus();
  tpWriteMeta();
  collectAll();
  scheduleSave();
});
/* recommendations and browse behave identically to click, preview and keyboard */
tpRecGrid.addEventListener('click', function(e){
  var exp = e.target.closest('[data-preview]');
  if(exp){ e.stopPropagation(); tpOpenPreview(exp.getAttribute('data-preview'), exp); return; }
  var card = e.target.closest('.tp-card');
  if(!card) return;
  tpToggle(card.getAttribute('data-url'), card.getAttribute('data-name'), card.getAttribute('data-img'), card, 'ai', parseInt(card.getAttribute('data-rank'), 10));
});
tpRecGrid.addEventListener('keydown', function(e){
  var exp = e.target.closest('.tp-expand');
  if(exp && (e.key === 'Enter' || e.key === ' ')){ e.preventDefault(); e.stopPropagation(); tpOpenPreview(exp.getAttribute('data-preview'), exp); }
});

function tpInit(){
  tpRender();
  document.getElementById('aiChips').innerHTML = AI_STARTERS.map(function(x){
    return '<button type="button" class="ai-chip" data-add="' + escHtml(x) + '">' + escHtml(x) + '</button>';
  }).join('');
  fetch(THEMES_URL, { cache: 'force-cache' }).then(function(r){ return r.json(); }).then(function(d){
    TP.data = d;
    if(d.lex) lexBuild();
    tpChipsRender();
    tpHydrate();
    tpRender();
    if(aiInput.value.trim()) tpRunMatch();
  }).catch(function(){ TP.failed = true; tpRender(); });
}
setTimeout(tpInit, 900);

/* ---------- budget tiers (monthly = total over 20) ---------- */
(function buildBudget(){
  var sel = document.getElementById('budget');
  function money(n){ return '$' + n.toLocaleString('en-US', {minimumFractionDigits:2}); }
  var opts = ['<option value="">Choose a range</option>', '<option value="not_sure">Not sure yet, help me size it</option>'];
  opts.push('<option value="template">Less than $1,999.95/mo, I am ok with a Template Build.</option>');
  [39999.99,59999.99,79999.99,99999.99,119999.99,139999.99,179999.99,199999.99,299999.99,399999.99,499999.99,599999.99,799999.99,999999.99].forEach(function(total){
    var monthly = Math.round(total/20) - 0.05;
    /* the monthly figure leads: the plan is what makes the number approachable */
    opts.push('<option value="'+Math.floor(total)+'">'+money(monthly)+'/mo · '+money(total)+' project</option>');
  });
  opts.push('<option value="1000000">More than $1,000,000.00</option>');
  sel.innerHTML = opts.join('');
})();

/* ---------- stack builder: scan, chips, quick picks, search ---------- */
(function stackBuilder(){
  var chipsEl = document.getElementById('sbChips');
  if(!chipsEl) return;
  var CATALOG = [
    ['NetSuite','ERP'],['Microsoft Dynamics 365','ERP'],['Acumatica','ERP'],['SAP','ERP'],['Odoo','ERP'],['Fishbowl','ERP'],['Brightpearl','ERP'],['Cin7','ERP'],
    ['QuickBooks','Accounting'],['Xero','Accounting'],['Sage','Accounting'],
    ['Salesforce','CRM'],['HubSpot','CRM'],['Zoho CRM','CRM'],
    ['Akeneo','PIM'],['Salsify','PIM'],['Plytix','PIM'],
    ['Celigo','Middleware'],['Boomi','Middleware'],['MuleSoft','Middleware'],['Zapier','Middleware'],['Make','Middleware'],['Alloy','Middleware'],
    ['ShipStation','Shipping'],['ShipBob','3PL'],['ShipHero','3PL'],['Deliverr','3PL'],['Flexport','3PL'],['Shippo','Shipping'],['EasyPost','Shipping'],
    ['Loop Returns','Returns'],['AfterShip','Tracking'],['Narvar','Post-purchase'],['Happy Returns','Returns'],
    ['Avalara','Tax'],['TaxJar','Tax'],['Vertex','Tax'],
    ['Signifyd','Fraud'],['Riskified','Fraud'],['NoFraud','Fraud'],['Forter','Fraud'],
    ['Klaviyo','Email and SMS'],['Attentive','SMS'],['Postscript','SMS'],['Omnisend','Email'],['Mailchimp','Email'],['Sendlane','Email'],
    ['Gorgias','Support'],['Zendesk','Support'],['Intercom','Support'],['Gladly','Support'],['Kustomer','Support'],
    ['Yotpo','Reviews'],['Okendo','Reviews'],['Judge.me','Reviews'],['Stamped','Reviews'],['Loox','Reviews'],['Trustpilot','Reviews'],['Bazaarvoice','Reviews'],
    ['Recharge','Subscriptions'],['Skio','Subscriptions'],['Appstle','Subscriptions'],['Stay.ai','Subscriptions'],['Bold Subscriptions','Subscriptions'],
    ['Smile.io','Loyalty'],['LoyaltyLion','Loyalty'],['Rivo','Loyalty'],
    ['Rebuy','Personalization'],['Nosto','Personalization'],['Dynamic Yield','Personalization'],
    ['Algolia','Search'],['Searchanise','Search'],['Boost','Search'],['Findify','Search'],
    ['Triple Whale','Analytics'],['Northbeam','Analytics'],['Elevar','Tracking'],['Hotjar','Analytics'],['Microsoft Clarity','Analytics'],['Google Analytics','Analytics'],['Google Tag Manager','Tags'],
    ['Meta Pixel','Ads'],['TikTok Pixel','Ads'],['Pinterest Tag','Ads'],['AdRoll','Ads'],['Criteo','Ads'],
    ['Shoplift','A/B testing'],['VWO','A/B testing'],['Optimizely','A/B testing'],
    ['Shogun','Page builder'],['PageFly','Page builder'],['GemPages','Page builder'],['Replo','Page builder'],
    ['Tapcart','Mobile app'],['Justuno','Popups'],['Privy','Popups'],
    ['Route','Shipping protection'],['Corso','Shipping protection'],
    ['Refersion','Affiliates'],['Impact','Affiliates'],['Tolstoy','Video'],['Videowise','Video'],
    ['OneTrust','Consent'],['accessiBe','Accessibility'],['UserWay','Accessibility']
  ];
  var QUICK = ['NetSuite','Microsoft Dynamics 365','Acumatica','QuickBooks','Xero','Salesforce','HubSpot','Avalara','ShipStation','Loop Returns'];
  var picked = [];
  function sync(){
    var ta = document.getElementById('appsCurrent');
    ta.value = picked.map(function(x){ return x.name; }).join('\n');
    ta.dispatchEvent(new Event('change', {bubbles:true}));
    render();
  }
  function has(n){ return picked.some(function(x){ return x.name.toLowerCase() === n.toLowerCase(); }); }
  function add(n, scanned){ if(!n || has(n)) return; picked.push({name:n, scanned:!!scanned}); sync(); }
  function remove(n){ picked = picked.filter(function(x){ return x.name !== n; }); sync(); }
  function render(){
    chipsEl.innerHTML = picked.length
      ? picked.map(function(x){
          return '<button type="button" class="sb-chip' + (x.scanned ? ' is-scanned' : '') + '" data-name="' + escHtml(x.name) + '" aria-label="Remove ' + escHtml(x.name) + '">' +
                 (x.scanned ? '✨ ' : '') + escHtml(x.name) + ' <span class="x">✕</span></button>';
        }).join('')
      : '<span class="sb-empty">Nothing yet. Scan, tap a quick pick, or search below.</span>';
    document.getElementById('sbQuick').innerHTML = QUICK.filter(function(q){ return !has(q); })
      .map(function(q){ return '<button type="button" class="tp-chip" data-quick="' + escHtml(q) + '">' + escHtml(q) + '</button>'; }).join('')
      || '<span class="sb-empty">All the usual suspects are in your list.</span>';
  }
  chipsEl.addEventListener('click', function(e){
    var b = e.target.closest('.sb-chip'); if(b) remove(b.getAttribute('data-name'));
  });
  document.getElementById('sbQuick').addEventListener('click', function(e){
    var b = e.target.closest('[data-quick]'); if(b) add(b.getAttribute('data-quick'));
  });
  var search = document.getElementById('sbSearch'), suggest = document.getElementById('sbSuggest');
  search.addEventListener('input', function(){
    var q = this.value.trim().toLowerCase();
    if(!q){ suggest.hidden = true; return; }
    var hits = CATALOG.filter(function(c){ return c[0].toLowerCase().indexOf(q) !== -1 && !has(c[0]); }).slice(0, 8);
    suggest.innerHTML = hits.map(function(c){
      return '<button type="button" data-add="' + escHtml(c[0]) + '" role="option">' + escHtml(c[0]) + ' <span class="cat">' + escHtml(c[1]) + '</span></button>';
    }).join('') + '<button type="button" data-add="' + escHtml(this.value.trim()) + '" role="option">Add \u201c' + escHtml(this.value.trim()) + '\u201d <span class="cat">as typed</span></button>';
    suggest.hidden = false;
  });
  search.addEventListener('keydown', function(e){
    if(e.key === 'Enter'){ e.preventDefault(); add(this.value.trim()); this.value = ''; suggest.hidden = true; }
    if(e.key === 'Escape'){ suggest.hidden = true; }
  });
  suggest.addEventListener('click', function(e){
    var b = e.target.closest('[data-add]'); if(!b) return;
    add(b.getAttribute('data-add')); search.value = ''; suggest.hidden = true; search.focus();
  });
  document.addEventListener('click', function(e){ if(!e.target.closest('.sb-search-wrap')) suggest.hidden = true; });
  var SCAN_STAGES = ['Reading your homepage\u2026','Opening a product page\u2026','Checking a collection\u2026','Peeking at the cart\u2026','Naming what we found\u2026'];
  document.getElementById('sbScanBtn').addEventListener('click', function(){
    var url = (state.store_url || document.getElementById('storeUrl').value || '').trim();
    var status = document.getElementById('sbStatus');
    if(!url){ status.hidden = false; status.textContent = 'Add your store URL a step back and the scan knows where to look.'; return; }
    var btn = this; btn.disabled = true;
    status.hidden = false;
    var stage = 0;
    status.textContent = SCAN_STAGES[0];
    var tick = setInterval(function(){ stage = Math.min(stage + 1, SCAN_STAGES.length - 1); status.textContent = SCAN_STAGES[stage]; }, 1800);
    fetch('https://test-drive.arcticgrey.org/stackscan', {
      method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({url:url})
    }).then(function(r){ return r.json(); }).then(function(d){
      clearInterval(tick); btn.disabled = false;
      if(!d.ok || !d.detected){ status.textContent = 'The scan could not read that site. Add your tools below instead.'; return; }
      d.detected.forEach(function(a){ add(a.name, true); });
      status.textContent = d.detected.length
        ? 'Found ' + d.detected.length + ' on ' + (d.platform || 'your store') + '. Tap any that do not belong, and add the backend tools below.'
        : 'That site keeps its secrets. Add your tools below and we take it from there.';
    }).catch(function(){ clearInterval(tick); btn.disabled = false; status.textContent = 'The scan could not reach that site. Add your tools below instead.'; });
  });
  window.__syncStackBuilder = function(){
    var v = (document.getElementById('appsCurrent').value || '');
    picked = v.split(/\n|\|/).map(function(x){ return x.trim(); }).filter(Boolean)
      .map(function(n){ return {name:n, scanned:false}; });
    render();
  };
  window.__syncStackDomain = function(){
    var d = document.getElementById('sbDomain');
    if(d) d.textContent = (state.store_url || document.getElementById('storeUrl').value || 'your store').replace(/^https?:\/\//,'');
  };
  render();
})();

/* ---------- sponsor calculator ---------- */
var sp = { rev:12000000, aov:85, annual:0, monthly:0, term:12, tier:'c', plat:'s', spYears:3, sbOn:true, asOn:true, spOn:false };
function fmt(n){ return '$' + Math.round(n).toLocaleString('en-US'); }
function num0(n){ return Math.round(n).toLocaleString('en-US'); }
var SP_MONTHLY = 2300;
function spAmt(){ return (FORM_TYPE === 'sponsors' && sp.spOn && sp.spYears) ? sp.spYears * SP_MONTHLY : 0; }
function num(el){ return parseFloat(String(el.value).replace(/[^0-9.]/g,'')) || 0; }
function setVal(id, n){ document.getElementById(id).value = Math.round(n).toLocaleString('en-US'); }
function meshFromRevenue(){
  sp.annual = sp.aov > 0 ? Math.round(sp.rev / sp.aov) : 0;
  sp.monthly = Math.round(sp.annual / 12);
}
/* program math, canon with sponsors.arcticgrey.org; engine rates stay out of copy */
var AS_RATES = { c:0.05, b:0.10, m:0.15 }, AS_MONTHS = 6, AS_FLOORS = { s:10000, o:20000 };
var AS_TIERS = { c:['Conservative','flexible placement'], b:['Baseline','above-the-fold placement'], m:['Maximum','top-of-page placement'] };
function sbEligible(){ return sp.rev >= 2000000 && sp.aov > 0 && sp.aov <= 500; }
function sbAmt(term){ return sbEligible() ? Math.round((term/18) * 0.004 * sp.rev) : 0; }
function asFloor(){ return AS_FLOORS[sp.plat]; }
function asEligible(){ return sp.monthly >= asFloor(); }
function asAmt(t){ return asEligible() ? Math.round(sp.monthly * AS_RATES[t || sp.tier] * AS_MONTHS) : 0; }
function asPerMonth(t){ return asEligible() ? Math.round(sp.monthly * AS_RATES[t || sp.tier]) : 0; }
function renderSponsor(){
  setVal('spRev', sp.rev); setVal('spAov', sp.aov); setVal('spAnnual', sp.annual); setVal('spMonthly', sp.monthly);
  [6,12,18].forEach(function(t){ document.getElementById('sbT'+t).textContent = fmt(sbAmt(t)); });
  ['c','b','m'].forEach(function(t){ document.getElementById('asT'+t).textContent = fmt(asAmt(t)); });

  /* three states, and they must not look alike: taken, turned down, or not yet available */
  function paintCard(prefix, on, eligible, amount, whyNot){
    var card = document.getElementById(prefix + 'Card') || document.getElementById(prefix + 'Program');
    var pill = document.getElementById(prefix + 'Pill');
    var tog = document.getElementById(prefix + 'Tog');
    var label = document.getElementById(prefix + 'TogLabel');
    var note = document.getElementById(prefix + 'Note');
    if(!card) return 0;
    var live = on && eligible;
    card.classList.toggle('is-on', live);
    card.classList.toggle('is-off', !on);
    card.classList.toggle('is-locked', on && !eligible);
    if(tog){
      tog.setAttribute('aria-pressed', on ? 'true' : 'false');
      if(label) label.textContent = on ? 'Included in my estimate' : 'Add to my estimate';
    }
    if(pill){
      pill.textContent = !on ? 'Not included' : (eligible ? 'Included' : 'Not eligible yet');
      pill.className = 'pill ' + (live ? 'pill-ok' : 'pill-warn');
    }
    if(note){
      note.textContent = (on && !eligible && whyNot) ? whyNot : '';
      note.className = 'prog-note' + ((on && !eligible) ? ' is-warn' : '');
    }
    document.getElementById(prefix + 'Amt' + (prefix === 'sp' ? 'El' : '')).textContent = fmt(live ? amount : 0);
    return live ? amount : 0;
  }

  var sbWhy = 'Available once trailing checkout revenue reaches $2M with an average order value at or under $500. Yours reads ' + fmt(sp.rev) + ' at ' + fmt(sp.aov) + '.';
  var asWhy = 'Eligible from ' + num0(asFloor()) + ' orders a month on this platform. You are at ' + num0(sp.monthly) + '.';
  var sb = paintCard('sb', sp.sbOn, sbEligible(), sbAmt(sp.term), sbWhy);
  var as = paintCard('as', sp.asOn, asEligible(), asAmt(), asWhy);
  /* when it is available the note carries the projection instead of the reason */
  if(sp.asOn && asEligible()){
    document.getElementById('asNote').textContent = AS_TIERS[sp.tier][0] + ', ' + AS_TIERS[sp.tier][1] + '. Around ' + fmt(asPerMonth()) + ' a month in projected ad revenue, a benchmark rather than a promise.';
    document.getElementById('asNote').className = 'prog-note';
  }
  /* the class alone told a sighted person which one was chosen; say it out loud too */
  function syncTiles(attr, want){
    document.querySelectorAll('[' + attr + ']').forEach(function(b){
      var on = String(b.getAttribute(attr)) === String(want);
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  syncTiles('data-tier', sp.tier);
  syncTiles('data-plat', sp.plat);
  syncTiles('data-term', sp.term);
  var spBox = document.getElementById('spProgram'), spTotal = 0;
  if(spBox && FORM_TYPE === 'sponsors'){
    spBox.hidden = false;
    [1,2,3].forEach(function(y){ document.getElementById('spY'+y).textContent = fmt(y * SP_MONTHLY); });
    syncTiles('data-yrs', sp.spYears);
    spTotal = paintCard('sp', sp.spOn, true, sp.spYears * SP_MONTHLY, '');
  }
  var total = sb + as + spTotal;
  document.getElementById('coverageTotal').textContent = fmt(total);
  var estField = document.getElementById('sponsorEstimateField');
  var inpField = document.getElementById('sponsorInputsField');
  var inputsStr = [sp.rev, sp.aov, sp.monthly, sp.term, sp.tier, sp.plat, (sp.spOn ? sp.spYears : 0), (sp.sbOn?1:0), (sp.asOn?1:0)].join('|');
  // The calculator initialises on every form, including the four that never show it.
  // Until someone actually moves something, these are our numbers, not theirs, and a
  // ticket that prints them reads as an answer the person never gave.
  if(estField) estField.value = spTouched ? String(total) : '';
  if(inpField) inpField.value = spTouched ? inputsStr : '';
  state.sponsor_estimate = estField ? estField.value : '';
  state.sponsor_inputs = inpField ? inpField.value : '';
}
var spTouched = false;
// any real interaction with the calculator, however small, makes the estimate theirs
['spRev','spAov','spAnnual','spMonthly'].forEach(function(id){
  var el = document.getElementById(id);
  if(el) el.addEventListener('input', function(){ spTouched = true; });
});
document.addEventListener('click', function(e){
  if(e.target.closest('[data-term],[data-tier],[data-plat],[data-yrs],.prog-toggle')) spTouched = true;
}, true);
document.getElementById('spRev').addEventListener('change', function(){ sp.rev = num(this); meshFromRevenue(); renderSponsor(); scheduleSave(); });
document.getElementById('spAov').addEventListener('change', function(){ sp.aov = num(this); meshFromRevenue(); renderSponsor(); scheduleSave(); });
document.getElementById('spAnnual').addEventListener('change', function(){
  sp.annual = num(this);
  if(sp.annual > 0){ sp.aov = Math.round((sp.rev / sp.annual) * 100) / 100; sp.monthly = Math.round(sp.annual / 12); }
  renderSponsor(); scheduleSave();
});
document.getElementById('spMonthly').addEventListener('change', function(){
  sp.monthly = num(this);
  var impliedAnnual = sp.monthly * 12;
  if(Math.abs(impliedAnnual - sp.annual) > 12){ sp.annual = impliedAnnual; if(sp.annual > 0) sp.aov = Math.round((sp.rev / sp.annual) * 100) / 100; }
  renderSponsor(); scheduleSave();
});
[['sbTog','sbOn'],['asTog','asOn'],['spTog','spOn']].forEach(function(pair){
  var el = document.getElementById(pair[0]);
  if(!el) return;
  el.addEventListener('click', function(){
    sp[pair[1]] = !sp[pair[1]];
    renderSponsor(); scheduleSave();
  });
});
document.querySelectorAll('.term-tile').forEach(function(tile){
  tile.addEventListener('click', function(){
    if(tile.hasAttribute('data-term')){
      document.querySelectorAll('[data-term]').forEach(function(t){ t.classList.remove('is-selected'); });
      tile.classList.add('is-selected');
      sp.term = parseInt(tile.getAttribute('data-term'), 10);
    } else if(tile.hasAttribute('data-tier')){
      sp.tier = tile.getAttribute('data-tier');
    } else if(tile.hasAttribute('data-plat')){
      sp.plat = tile.getAttribute('data-plat');
    } else if(tile.hasAttribute('data-yrs')){
      sp.spYears = parseInt(tile.getAttribute('data-yrs'), 10);
      sp.spOn = true;
    }
    renderSponsor(); scheduleSave();
  });
});
/* whatever they entered on any form comes back here rather than being asked twice */
function restoreSponsorInputs(raw){
  var b = String(raw || '').split('|');
  if(b.length < 3) return false;
  var rev = parseFloat(b[0]), aov = parseFloat(b[1]);
  if(!(rev > 0)) return false;
  sp.rev = rev;
  if(aov > 0) sp.aov = aov;
  meshFromRevenue();
  if(b[2] && parseFloat(b[2]) > 0) sp.monthly = Math.round(parseFloat(b[2]));
  if(b[3] && [6,12,18].indexOf(parseInt(b[3],10)) !== -1) sp.term = parseInt(b[3],10);
  if(b[4] && AS_RATES[b[4]] !== undefined) sp.tier = b[4];
  if(b[5] === 's' || b[5] === 'o') sp.plat = b[5];
  if(b[6] && [1,2,3].indexOf(parseInt(b[6],10)) !== -1){ sp.spYears = parseInt(b[6],10); sp.spOn = true; }
  if(b[7] !== undefined && b[7] !== '') sp.sbOn = b[7] === '1';
  if(b[8] !== undefined && b[8] !== '') sp.asOn = b[8] === '1';
  document.querySelectorAll('[data-term]').forEach(function(t){ t.classList.toggle('is-selected', parseInt(t.getAttribute('data-term'),10) === sp.term); });
  spTouched = true; /* restored figures are theirs, so they re-emit on every save */
  renderSponsor();
  return true;
}
window.__restoreSponsor = restoreSponsorInputs;
meshFromRevenue(); renderSponsor();

/* ---------- platform smart search ----------
   Catalog anchors on the 50 sitemap-verified ai-migrate-from pages,
   extended with enterprise, regional, and marketplace platforms. */
var PLATFORMS = [
  ['Magento / Adobe Commerce', ['Adobe Commerce','Magento 2','M2']],
  ['Magento Open Source', ['Magento 1','M1']],
  ['BigCommerce', []],
  ['WooCommerce', ['Woo']],
  ['NetSuite SuiteCommerce', ['SuiteCommerce','SCA','NetSuite']],
  ['Salesforce Commerce Cloud', ['Demandware','SFCC']],
  ['Salesforce B2B Commerce', ['CloudCraze']],
  ['WordPress', ['WP']],
  ['VTEX', ['Vertex']],
  ['Shopify', ['Shopify Plus']],
  ['Squarespace', []],
  ['Wix', ['Wix Stores']],
  ['SAP Commerce Cloud', ['Hybris','SAP Hybris']],
  ['Oracle Commerce', ['ATG','Oracle ATG']],
  ['commercetools', []],
  ['Elastic Path', []],
  ['Kibo Commerce', ['Mozu']],
  ['Optimizely Commerce', ['Episerver']],
  ['Sitecore OrderCloud', ['Sitecore Commerce']],
  ['Intershop', []],
  ['Digital River', []],
  ['Spryker', []],
  ['OroCommerce', []],
  ['Sana Commerce', []],
  ['Znode', []],
  ['Workarea', []],
  ['Broadleaf Commerce', []],
  ['Sylius', []],
  ['Spree Commerce', []],
  ['Solidus', []],
  ['Saleor', []],
  ['Medusa', []],
  ['Shopware', []],
  ['OXID eShop', []],
  ['Plentymarkets', []],
  ['JTL-Shop', []],
  ['Gambio', []],
  ['ePages', []],
  ['EKM', []],
  ['Zyro', []],
  ['PrestaShop', []],
  ['OpenCart', []],
  ['osCommerce', []],
  ['Zen Cart', []],
  ['X-Cart', []],
  ['CS-Cart', []],
  ['CubeCart', []],
  ['nopCommerce', []],
  ['AmeriCommerce', []],
  ['CoreCommerce', []],
  ['Pinnacle Cart', []],
  ['ShopSite', []],
  ['Interspire', []],
  ['Miva Merchant', ['Miva']],
  ['Volusion', []],
  ['Shift4Shop', ['3dcart']],
  ['UltraCart', []],
  ['FoxyCart', []],
  ['Snipcart', []],
  ['Ecwid', []],
  ['Lightspeed eCom', ['Lightspeed']],
  ['Vend by Lightspeed', ['Vend']],
  ['Square Online', ['Square','Weebly Commerce']],
  ['Weebly', []],
  ['GoDaddy Website Builder', ['GoDaddy']],
  ['Jimdo', []],
  ['IONOS MyWebsite', ['1and1','IONOS']],
  ['Duda', []],
  ['Webflow', []],
  ['Webnode', []],
  ['Big Cartel', []],
  ['Storenvy', []],
  ['Drupal Commerce', ['Drupal']],
  ['Ubercart', []],
  ['VirtueMart', ['Joomla']],
  ['WP eCommerce', []],
  ['Easy Digital Downloads', ['EDD']],
  ['SureCart', []],
  ['Kajabi', []],
  ['Podia', []],
  ['Gumroad', []],
  ['Sellfy', []],
  ['Payhip', []],
  ['SamCart', []],
  ['ThriveCart', []],
  ['ClickFunnels', []],
  ['Shopline', []],
  ['Shoplazza', []],
  ['ShopBase', []],
  ['Haravan', []],
  ['Cafe24', []],
  ['MakeShop', []],
  ['EC-CUBE', []],
  ['BASE', []],
  ['STORES', []],
  ['Rakuten', []],
  ['Tiendanube / Nuvemshop', ['Nuvemshop','Tiendanube']],
  ['Tray Commerce', ['Tray']],
  ['Loja Integrada', []],
  ['Mercado Shops', ['Mercado Libre']],
  ['Shoper', []],
  ['Turbify', ['Yahoo Store','Yahoo Small Business']],
  ['Amazon', ['Amazon Seller','FBA']],
  ['eBay', []],
  ['Etsy', []],
  ['Walmart Marketplace', ['Walmart']],
  ['Faire', []],
  ['TikTok Shop', ['TikTok']],
  ['Facebook & Instagram Shops', ['Meta Shops','Instagram']],
  ['Custom-built', ['Custom','Bespoke','In-house']],
  ['Other', []]
];

var platformHidden = document.getElementById('platformHidden');
var platformSearch = document.getElementById('platformSearch');
var platformList = document.getElementById('platformListbox');
var platformWrap = platformSearch.closest('.combo-wrap');
var platformPills = document.getElementById('platformPills');
var comboActive = -1, comboMatches = [];

function escHtml(s){ return s.replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
function markMatch(name, q){
  var i = name.toLowerCase().indexOf(q.toLowerCase());
  if(i === -1) return escHtml(name);
  return escHtml(name.slice(0,i)) + '<mark>' + escHtml(name.slice(i, i+q.length)) + '</mark>' + escHtml(name.slice(i+q.length));
}
function rankPlatforms(q){
  var ql = q.toLowerCase();
  var scored = [];
  PLATFORMS.forEach(function(entry){
    var name = entry[0], aliases = entry[1];
    var hay = [name].concat(aliases);
    var best = -1, via = '';
    hay.forEach(function(h){
      var hl = h.toLowerCase(), s = -1;
      if(hl.indexOf(ql) === 0) s = 3;
      else if(hl.split(/[\s/&-]+/).some(function(w){ return w.indexOf(ql) === 0; })) s = 2;
      else if(hl.indexOf(ql) !== -1) s = 1;
      if(s > best){ best = s; via = h; }
    });
    if(best > 0) scored.push({name:name, via:via, score:best});
  });
  scored.sort(function(a,b){ return b.score - a.score || a.name.localeCompare(b.name); });
  return scored.slice(0, 8);
}
function renderCombo(q){
  comboMatches = q ? rankPlatforms(q) : [];
  comboActive = -1;
  if(!q){ closeCombo(); return; }
  var html = comboMatches.map(function(m, i){
    var aliasIsNew = m.via !== m.name && m.name.toLowerCase().indexOf(m.via.toLowerCase()) === -1;
    var aliasNote = aliasIsNew ? '<span class="alias">· ' + markMatch(m.via, q) + '</span>' : '';
    return '<li class="combo-opt" role="option" id="combo-opt-' + i + '" data-name="' + escHtml(m.name) + '">' + markMatch(m.name, q) + aliasNote + '</li>';
  }).join('');
  if(!comboMatches.length){
    html = '<li class="combo-empty">No match for "' + escHtml(q) + '". <button type="button" id="comboPickOther">Pick Other and tell us</button></li>';
  }
  platformList.innerHTML = html;
  platformList.classList.add('is-open');
  platformSearch.setAttribute('aria-expanded', 'true');
}
function closeCombo(){
  platformList.classList.remove('is-open');
  platformSearch.setAttribute('aria-expanded', 'false');
  platformSearch.removeAttribute('aria-activedescendant');
  comboActive = -1;
}
function setPlatform(name, fromPill){
  platformHidden.value = name || '';
  platformWrap.classList.toggle('has-value', !!name);
  platformSearch.value = name || '';
  platformPills.querySelectorAll('.chip').forEach(function(pill){
    var on = !!name && pill.getAttribute('data-platform') === name;
    pill.classList.toggle('is-selected', on);
    pill.setAttribute('aria-pressed', on ? 'true' : 'false');
    if(on && fromPill){
      pill.classList.remove('is-pulsing'); void pill.offsetWidth; pill.classList.add('is-pulsing');
      setTimeout(function(){ pill.classList.remove('is-pulsing'); }, 600);
    }
  });
  closeCombo();
  platformHidden.dispatchEvent(new Event('change', {bubbles:true}));
}
window.__syncPlatformUI = function(){ setPlatform(platformHidden.value || ''); };

platformSearch.addEventListener('input', function(){
  if(platformWrap.classList.contains('has-value')){
    platformWrap.classList.remove('has-value');
    platformHidden.value = '';
    platformPills.querySelectorAll('.chip').forEach(function(p){ p.classList.remove('is-selected'); p.setAttribute('aria-pressed','false'); });
  }
  renderCombo(this.value.trim());
});
platformSearch.addEventListener('keydown', function(e){
  if(!platformList.classList.contains('is-open')){
    if(e.key === 'ArrowDown' && this.value.trim()){ renderCombo(this.value.trim()); e.preventDefault(); }
    return;
  }
  var opts = platformList.querySelectorAll('.combo-opt');
  if(e.key === 'ArrowDown' || e.key === 'ArrowUp'){
    e.preventDefault();
    if(!opts.length) return;
    comboActive = e.key === 'ArrowDown'
      ? (comboActive + 1) % opts.length
      : (comboActive - 1 + opts.length) % opts.length;
    opts.forEach(function(o, i){ o.classList.toggle('is-active', i === comboActive); });
    platformSearch.setAttribute('aria-activedescendant', 'combo-opt-' + comboActive);
    opts[comboActive].scrollIntoView({block:'nearest'});
  } else if(e.key === 'Enter'){
    e.preventDefault();
    e.stopPropagation();
    if(comboActive >= 0 && opts[comboActive]) setPlatform(opts[comboActive].getAttribute('data-name'));
    else if(opts.length === 1) setPlatform(opts[0].getAttribute('data-name'));
  } else if(e.key === 'Escape'){
    e.stopPropagation();
    closeCombo();
  }
});
platformList.addEventListener('mousedown', function(e){
  var opt = e.target.closest('.combo-opt');
  if(opt){ e.preventDefault(); setPlatform(opt.getAttribute('data-name')); return; }
  if(e.target.id === 'comboPickOther'){ e.preventDefault(); setPlatform('Other'); }
});
platformSearch.addEventListener('blur', function(){ setTimeout(closeCombo, 150); });
document.getElementById('platformClear').addEventListener('click', function(){
  setPlatform('');
  platformSearch.focus();
});
platformPills.addEventListener('click', function(e){
  var pill = e.target.closest('.chip');
  if(!pill) return;
  var name = pill.getAttribute('data-platform');
  setPlatform(platformHidden.value === name ? '' : name, true);
});

/* ---------- dropzones (one shared master file list, two entry points) ---------- */
var fileNames = [];
function fmtSize(n){ return n > 1048576 ? (n/1048576).toFixed(1) + ' MB' : Math.max(1, Math.round(n/1024)) + ' KB'; }
/* leaving mid-upload risks a lost file: warn while any upload is in flight */
var activeUploads = 0;
function uploadGuard(e){ e.preventDefault(); e.returnValue = ''; }
function trackUpload(delta){
  activeUploads = Math.max(0, activeUploads + delta);
  if(activeUploads === 1 && delta > 0) window.addEventListener('beforeunload', uploadGuard);
  if(activeUploads === 0) window.removeEventListener('beforeunload', uploadGuard);
}
/* an allowlist matching the backend's: archives, svg, html, macro Office files,
   programs and scripts go by shared link, never through our Drive (Round 27) */
var ALLOWED_EXT = /\.(pdf|png|jpe?g|gif|webp|heic|heif|avif|tiff?|docx|xlsx|pptx|csv|txt|ai|psd|otf|ttf|woff2?|mp4|mov)$/i;
function uploadFileToBackend(f, li, attempt){
  if(DEMO_MODE || regionBlocked) return;
  attempt = attempt || 1;
  if(attempt === 1) trackUpload(1);
  var sizeEl = li.querySelector('.f-size');
  sizeEl.textContent = 'uploading…';
  var reader = new FileReader();
  reader.onload = function(){
    var b64 = String(reader.result).split(',')[1] || '';
    fetch(ENDPOINT, {
      method:'POST', headers:{'Content-Type':'text/plain;charset=utf-8'},
      credentials:'omit', redirect:'follow', cache:'no-store', mode:'cors',
      body: JSON.stringify({upload:true, submission_id: submissionId, filename: f.name, mimetype: f.type || 'application/octet-stream', data: b64})
    })
    .then(function(r){ return r.json(); })
    .then(function(res){
      if(!res.ok && (res.error === 'refused' || res.error === 'region')){
        /* a refusal is a verdict, not a hiccup: no retries */
        sizeEl.textContent = 'not accepted · share it as a link below';
        trackUpload(-1);
        live.textContent = f.name + ' could not be accepted. Share it as a link in the shared-folder field instead.';
        return;
      }
      if(!res.ok) throw new Error(res.error || 'upload failed');
      sizeEl.textContent = fmtSize(f.size) + ' ✓';
      trackUpload(-1);
      live.textContent = f.name + ' uploaded';
      if(res.folder){
        document.getElementById('assetFolder').value = res.folder;
        collectAll(); scheduleSave();
      }
    })
    .catch(function(){
      if(attempt < 3){
        sizeEl.textContent = 'retrying…';
        setTimeout(function(){ uploadFileToBackend(f, li, attempt + 1); }, attempt * 2500);
      } else {
        sizeEl.textContent = 'upload failed · add a link below instead';
        trackUpload(-1);
        live.textContent = f.name + ' failed to upload. Share it as a link in the shared-folder field instead.';
      }
    });
  };
  reader.onerror = function(){ sizeEl.textContent = 'read failed · name saved'; trackUpload(-1); };
  reader.readAsDataURL(f);
}
function addFiles(list, listEl){
  Array.prototype.forEach.call(list, function(f){
    if(f.size > 25*1024*1024){ toast(f.name + ' is over 25MB. Use a shared folder link instead.'); return; }
    if(!ALLOWED_EXT.test(f.name)){ toast(f.name + ' is a file type we cannot accept here. Use a shared folder link instead.'); return; }
    if(fileNames.indexOf(f.name) !== -1){ toast('That file is already attached.'); return; }
    fileNames.push(f.name);
    var li = document.createElement('li');
    li.className = 'file-row';
    li.innerHTML = '<span class="f-name"></span><span class="f-size">' + fmtSize(f.size) + '</span><button type="button" aria-label="Remove file">✕</button>';
    li.querySelector('.f-name').textContent = f.name;
    li.querySelector('button').addEventListener('click', function(){
      fileNames = fileNames.filter(function(n){ return n !== f.name; });
      li.remove(); scheduleSave();
    });
    listEl.appendChild(li);
    uploadFileToBackend(f, li);
  });
  scheduleSave();
}
function bindDropzone(zoneId, inputId, listId){
  var dz = document.getElementById(zoneId);
  var input = document.getElementById(inputId);
  var listEl = document.getElementById(listId);
  dz.addEventListener('click', function(){ input.click(); });
  dz.addEventListener('keydown', function(e){ if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); input.click(); } });
  input.addEventListener('change', function(){ addFiles(this.files, listEl); this.value = ''; });
  ['dragenter','dragover'].forEach(function(ev){ dz.addEventListener(ev, function(e){ e.preventDefault(); dz.classList.add('is-drag'); }); });
  ['dragleave','drop'].forEach(function(ev){ dz.addEventListener(ev, function(e){ e.preventDefault(); dz.classList.remove('is-drag'); }); });
  dz.addEventListener('drop', function(e){ if(e.dataTransfer && e.dataTransfer.files) addFiles(e.dataTransfer.files, listEl); });
}
bindDropzone('dropzone', 'fileInput', 'fileList');
bindDropzone('aiDropzone', 'aiFileInput', 'aiFileList');

/* provider detection on the link row */
document.getElementById('assetLink').addEventListener('input', function(){
  var v = this.value.toLowerCase();
  var tag = document.getElementById('providerTag');
  var name = v.indexOf('drive.google') !== -1 ? 'Drive'
           : v.indexOf('dropbox') !== -1 ? 'Dropbox'
           : v.indexOf('figma') !== -1 ? 'Figma'
           : v.indexOf('notion') !== -1 ? 'Notion'
           : v.indexOf('sharepoint') !== -1 || v.indexOf('onedrive') !== -1 ? 'OneDrive'
           : (v.startsWith('http') ? 'Link' : '');
  tag.textContent = name;
  tag.classList.toggle('is-on', !!name);
});

/* ---------- finish now (lazy path) ---------- */
var finishBtn = document.createElement('button');
finishBtn.type = 'button';
finishBtn.className = 'link-quiet';
finishBtn.textContent = 'Finish now, Arctic Grey figures out the rest';
finishBtn.addEventListener('click', function(){ collectAll(); forceSave(); show('contact'); });
['designGate','styleTiles','sliders','latitude','features','ai','assets','featureThis','oneThing'].forEach(function(id){
  var row = stepEls[id].querySelector('.btn-row');
  var clone = finishBtn.cloneNode(true);
  clone.addEventListener('click', function(){ collectAll(); forceSave(); show('contact'); });
  row.appendChild(clone);
});

/* ---------- submit ---------- */
document.getElementById('submitBtn').addEventListener('click', function(){
  if(completed) return; /* double-submit guard */
  /* a resumed or prefilled session can land past a required step without ever
     seeing it; the sweep walks every step of THIS form before anything submits */
  var sweep = visibleSteps();
  for(var si = 0; si < sweep.length; si++){
    var sid = sweep[si];
    if(sid === 'welcome' || sid === 'contact' || sid === 'thanks') continue;
    if(!validate(sid)){ show(sid); return; }
  }
  var consent = form.querySelector('input[name="consent"]').checked;
  setErr('consentError', !consent);
  if(!consent) return;
  if(!EMAIL_RE.test((state.email||''))){ show('welcome'); return; }
  if(regionGate_()) return;
  completed = true;
  this.disabled = true;
  this.textContent = 'Submitted ✓';
  completedExtra = {consent_ts: new Date().toISOString(), turnstile_token: (window.__agTs && window.__agTs.token) || ''};
  completedId = submissionId;
  forceSave({completed:true, consent_ts: completedExtra.consent_ts, turnstile_token: completedExtra.turnstile_token});
  fireConversionBeacon();
  var ref = document.getElementById('refLine');
  if(ref) ref.textContent = 'Your reference: ' + String(submissionId).slice(0, 8);
  show('thanks');
  document.getElementById('progressLabel').textContent = 'Done';
  /* honest sync status: only claim synced when the queue actually drains */
  setTimeout(function(){
    var q = [];
    try{ q = JSON.parse(store.get(LS.queue) || '[]'); }catch(err){}
    var sy = document.getElementById('tySync');
    if(sy && q.length){ sy.textContent = 'Finishing sync, keep this tab open a few more seconds.'; }
  }, 1500);
});
/* ---------- region gate (Round 27) ---------- */
/* Anthony, 2026-10-19: real customers in, threats out. Sanctioned countries and
   the junk sources in our own tickets are turned away at the door and nothing is
   kept: no row, no draft on this device, no beacon. Either signal is enough: the
   IP country (the worker's /whoami, Cloudflare's view) or a timezone (the
   browser's or the IP's), so a Moscow visitor on a US VPN is still caught. The
   backend refuses the same list for anything that skips this page. */
var BLOCKED_CC = ['RU','BY','IR','KP','SY','CU','SO','NG','GH','CM','UG','TZ','GN','BD','PK','IQ','IN'];
var BLOCKED_TZ = /^(Europe\/(Moscow|Kaliningrad|Samara|Volgograd|Kirov|Astrakhan|Saratov|Ulyanovsk|Simferopol|Minsk)|Asia\/(Yekaterinburg|Omsk|Novosibirsk|Barnaul|Tomsk|Novokuznetsk|Krasnoyarsk|Irkutsk|Chita|Yakutsk|Khandyga|Vladivostok|Ust-Nera|Magadan|Sakhalin|Srednekolymsk|Kamchatka|Anadyr|Tehran|Pyongyang|Damascus|Dhaka|Dacca|Karachi|Baghdad|Kolkata|Calcutta)|America\/Havana|Africa\/(Mogadishu|Lagos|Accra|Douala|Kampala|Dar_es_Salaam|Conakry)|Cuba|Iran|W-SU)$/;
var regionBlocked = false;
function regionVerdict_(){
  var tz = '';
  try{ tz = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; }catch(e){}
  var g = window.__agGeo || {};
  if(g.country && BLOCKED_CC.indexOf(String(g.country).toUpperCase()) !== -1) return true;
  if(tz && BLOCKED_TZ.test(tz)) return true;
  if(g.timezone && BLOCKED_TZ.test(String(g.timezone))) return true;
  return false;
}
function regionGate_(){
  if(regionBlocked) return true;
  if(!regionVerdict_()) return false;
  regionBlocked = true;
  /* a row that slipped in before /whoami answered is silenced server-side by one
     last body carrying only its id and its place; nothing else is ever sent */
  if(kickoffSent && !DEMO_MODE){
    try{
      var g = window.__agGeo || {}, tz = '';
      try{ tz = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; }catch(e){}
      navigator.sendBeacon(ENDPOINT, JSON.stringify({submission_id: submissionId, geo_cc: g.country || '', geo_tz: g.timezone || '', timezone: tz}));
    }catch(e){}
  }
  try{ store.set(LS.queue, '[]'); }catch(e){}
  try{ store.set(LS.draft + submissionId, ''); }catch(e){}
  clearTimeout(saveTimer); clearTimeout(maxWaitTimer);
  document.body.classList.add('ag-region-blocked');
  var panel = document.getElementById('regionPanel');
  if(panel){ panel.hidden = false; var h = panel.querySelector('h2'); if(h) h.focus(); }
  return true;
}
regionGate_();

/* a required step must not promise "skip it if you prefer" */
(function requiredCopy(){
  var r = REQUIRED_BY_FORM[FORM_TYPE] || {};
  Object.keys(r).forEach(function(id){
    var el = stepEls[id] && stepEls[id].querySelector('.lede[data-required-lede]');
    if(el) el.textContent = el.getAttribute('data-required-lede');
  });
})();

var beaconFired = false;
function fireConversionBeacon(){
  if(beaconFired || regionBlocked) return;
  beaconFired = true;
  var payload = {
    type: 'form_submit',
    email: (state.email || '').trim().toLowerCase(),  /* hashed server-side, never stored raw */
    gclid: attribution.gclid || '',
    li_fat_id: attribution.li_fat_id || '',
    fbclid: attribution.fbclid || '',
    utm: {
      utm_source: attribution.utm_source || '',
      utm_medium: attribution.utm_medium || '',
      utm_campaign: attribution.utm_campaign || '',
      utm_content: attribution.utm_content || '',
      utm_term: attribution.utm_term || ''
    },
    contact_id: attribution.c || '',
    page: location.pathname,
    ts: new Date().toISOString(),
    source: state.agent_prefill === 'yes' ? FORM_CFG.source + '-agent' : FORM_CFG.source,
    filled_by: state.filled_by || '',
    secret: FORM_SECRET
  };
  if(DEMO_MODE){
    console.log('[demo] factory beacon →', FACTORY_BEACON, payload);
    return;
  }
  try{ navigator.sendBeacon(FACTORY_BEACON, JSON.stringify(payload)); }catch(e){}
}

/* ---------- agent access layer: prefill engine ---------- */
var ENUMS = {
  situation:['new_store','redesign','migrate','exploring'],
  revenue:['under_5m','5m_20m','20m_200m','200m_plus','not_sure'],
  launch:['90_days','3_6_months','6_12_months','exploring'],
  scope:['custom','template','recommend'],
  budget:['not_sure','template','39999','59999','79999','99999','119999','139999','179999','199999','299999','399999','499999','599999','799999','999999','1000000'],
  sponsor_interest:['yes','no'],
  design_gate:['preferences','ag_leads'],
  latitude:['strict','evolve','free_range'],
  role:['founder','ecommerce','marketing','engineering','ops_finance','other'],
  app_type:['custom','private','public','not_sure'],
  app_monetization:['subscription','free_paid','one_time','usage','not_sure'],
  shopify_plan:['basic','shopify','advanced','plus','dont_know'],
  years_on_shopify:['lt_1','1_3','3_5','5_plus'],
  store_theme:['dawn','impact','custom','paid_theme','dont_know'],
  feedback_mood:['delighted','good','mixed','frustrated'],
  feedback_again:['yes','maybe','no'],
  review_rating:['excellent','good','okay','bad','very_bad'],
  review_permission:['full','first_name','private'],
  ag_contact:['Anthony Spallone','Autumn Nguyen','Brooke Sanderson','Callie Orourke','Camilo Ospina','Caroline Jay','Edna Shuli','Giana Moretti','Hugo Silva','Humara Kausar','Jake Amos','Jenn Baratto','Julia Matviichuk','Leana Zhang','Maddie Schwartz','Payton Balabanoff','Sofia Jimenez','Talia Ceraso','Thiara Fernández','Truc Peter','Vanessa Esquinazi','Not sure']
};
ENUMS.careers_team = ['solutions','development','design','project_management','support','qa','marketing','assistant'];
var ARRAYS = {
  features:['subscriptions','product_builder','b2b','pos','bundles','loyalty','quiz','multicurrency','erp','shipping','other'],
  channels:['email','sms','paid_social','paid_search','seo','cro','affiliate','marketplaces','not_sure'],
  carry_history:['customers','orders','redirects','reviews','subscriptions','gift_cards'],
  b2b_ordering:['portal','email_phone','rep','edi','marketplace','not_sure'],
  app_surfaces:['admin','storefront','checkout','customer_accounts','pos','backend'],
  audit_focus:['cro','aov','retention','speed','seo','subscriptions','checkout','search','not_sure'],
  audit_leak:['homepage','collection','product','cart','checkout','post_purchase','not_sure'],
  store_traits:['headless','multi_region','b2b','subscriptions'],
  esp:['klaviyo','attentive','postscript','mailchimp','other','none'],
  feedback_strengths:['design','development','qa','management','reports','communication','deliverables','expertise','scope','speed'],
  feedback_gaps:['design','development','qa','management','reports','communication','deliverables','expertise','scope','speed'],
  review_channels:['website','google','clutch','shopify','social']
};
// a slider only earns its name once the person has moved it, so an untouched one
// contributes nothing to FormData rather than shipping our default as their taste
// A slider parks its name in data-name until it is answered. Anything that applies a
// stored value is applying a real answer, so it takes the name back on the way in.
function fieldsNamed(name){
  var found = form.querySelectorAll('[name="' + name + '"]');
  /* a few names live on two forms' steps (competitors is on the audit context
     step and the bulk-hours competitors card). Both sections sit in the DOM at
     once, so restore and prefill must aim at the one this form actually shows,
     or a bulk-hours row repaints into the hidden audit input and the visible
     field stays blank. */
  if(found.length > 1){
    var vs = visibleSteps();
    var mine = [].filter.call(found, function(el){
      var sec = el.closest('.step');
      return !sec || vs.indexOf(sec.getAttribute('data-step')) !== -1;
    });
    if(mine.length) return mine;
  }
  if(found.length) return found;
  var parked = form.querySelectorAll('[data-name="' + name + '"]');
  parked.forEach(function(el){ el.name = name; el.dataset.wasParked = '1'; });
  return parked;
}
document.querySelectorAll('input[type="range"][data-name]').forEach(function(r){
  r.addEventListener('input', function(){
    if(!this.name){ this.name = this.getAttribute('data-name'); scheduleSave(); }
  }, {once:false});
});
var TEXTS = ['apps_current','apps_replace','app_integrations','test_page','competitors','hours_tasks','design_prompt','email','first_name','last_name','company','store_url','loved_sites','features_other','prior_work','asset_link','feature_products','one_thing','phone','filled_by','role_other','message','audit_north_star','audit_leak_note','audit_margin_heroes','audit_recent_changes','audit_off_limits','esp_other','feedback_pain','feedback_change','feedback_delight','review_headline','review_text','review_video','app_description','app_examples','careers_role'];
var SLIDERS = ['slider_vibe','slider_density','slider_shape','slider_tone'];

function b64urlDecode(s){
  s = s.replace(/-/g,'+').replace(/_/g,'/');
  while(s.length % 4) s += '=';
  try{ return decodeURIComponent(escape(atob(s))); }catch(e){ return null; }
}
function resolvePlatform(raw){
  var rl = String(raw).toLowerCase();
  for(var i = 0; i < PLATFORMS.length; i++){
    var hay = [PLATFORMS[i][0]].concat(PLATFORMS[i][1]);
    for(var j = 0; j < hay.length; j++){
      if(hay[j].toLowerCase() === rl) return PLATFORMS[i][0];
    }
  }
  return String(raw).slice(0, 80);
}
function checkByValue(name, val){
  var inp = form.querySelector('input[name="' + name + '"][value="' + val + '"]');
  if(inp){ inp.checked = true; syncVisual(inp); return true; }
  return false;
}
function applyPrefill(){
  var p = new URLSearchParams(location.search);
  var data = {};
  var blob = p.get('prefill');
  if(blob){
    var decoded = b64urlDecode(blob);
    if(decoded){ try{ var parsed = JSON.parse(decoded); if(parsed && typeof parsed === 'object') data = parsed; }catch(e){} }
  }
  p.forEach(function(v, k){ if(k !== 'prefill') data[k] = v; });
  var keys = Object.keys(data);
  if(!keys.length) return;

  var applied = 0;
  TEXTS.forEach(function(k){
    if(typeof data[k] === 'string' && data[k].trim()){
      var el = fieldsNamed(k)[0];
      if(el){ el.value = data[k].trim(); applied++; }
    }
  });
  Object.keys(ENUMS).forEach(function(k){
    var v = data[k] != null ? String(data[k]) : '';
    if(v && ENUMS[k].indexOf(v) !== -1){
      if(k === 'budget'){ document.getElementById('budget').value = v; applied++; }
      else if(checkByValue(k, v)) applied++;
    }
  });
  Object.keys(ARRAYS).forEach(function(k){
    var vals = data[k];
    if(typeof vals === 'string') vals = vals.split(/[|,]/).map(function(s){ return s.trim(); });
    if(Array.isArray(vals)){
      vals.filter(function(v){ return ARRAYS[k].indexOf(v) !== -1; })
          .forEach(function(v){ if(checkByValue(k, v)) applied++; });
    }
  });
  SLIDERS.forEach(function(k){
    var n = parseInt(data[k], 10);
    if(!isNaN(n)){ var sl = fieldsNamed(k)[0]; if(sl){ sl.value = Math.max(0, Math.min(100, n)); applied++; } }
  });
  if(typeof data.theme_picks === 'string' && data.theme_picks.trim()){
    var tpSegs = data.theme_picks.split('|').map(function(x){ return x.trim(); })
      .filter(function(x){ return x.indexOf(' :: https://themes.shopify.com') !== -1; }).slice(0, 3);
    if(tpSegs.length){
      var tpEl = document.getElementById('themePicks');
      if(tpEl){ tpEl.value = tpSegs.join(' | '); if(window.__syncThemePicker) window.__syncThemePicker(); applied++; }
    }
  }
  var pRev = parseFloat(String(data.sponsor_revenue || '').replace(/[^0-9.]/g, ''));
  var pAov = parseFloat(String(data.sponsor_aov || '').replace(/[^0-9.]/g, ''));
  if(pRev > 0 && typeof window.__restoreSponsor === 'function'){
    window.__restoreSponsor(pRev + '|' + (pAov > 0 ? pAov : '') + '|');
    applied++;
  }
  if(data.no_site === 'yes'){
    var ns = form.querySelector('input[name="no_site"]');
    ns.checked = true; syncVisual(ns); applied++;
  }
  if(data.platform){ setPlatform(resolvePlatform(data.platform)); applied++; }
  if(data.filled_by) document.getElementById('filledBy').value = String(data.filled_by).slice(0, 40);
  /* consent is human-only by design: never applied from prefill */

  if(!applied) return;

  var sit = form.querySelector('input[name="situation"]:checked');
  if(sit) sit.dispatchEvent(new Event('change', {bubbles:true}));
  var feat = form.querySelector('input[name="features"][value="other"]:checked');
  if(feat) document.getElementById('featuresOther').style.display = 'block';

  var agentMode = !!(blob || data.filled_by);
  document.getElementById('agentPrefill').value = agentMode ? 'yes' : '';
  collectAll();
  /* only a declared agent handoff earns an immediate row; a bare ?email= link
     (teammate invite, resume email) waits for the gate, which knows whether a
     row already exists. Kicking off here is how duplicate shells were minted. */
  if(agentMode){
    tryKickoff(true);
    scheduleSave();
  }

  if(agentMode){
    document.getElementById('prefillBanner').hidden = false;
    if(EMAIL_RE.test((state.email || ''))){ show('contact', false); }
  }
}
document.getElementById('pbReviewBtn').addEventListener('click', function(){
  var v = visibleSteps();
  show(v.indexOf('situation') !== -1 ? 'situation' : v[Math.min(1, v.length - 1)]);
});

/* ---------- AI panel: the copyable master prompt ---------- */
var AI_ASKS = {
  'test-drive': 'Required: my email, first name, my company or brand name, my situation (new_store, redesign, migrate, or exploring), and my store URL (or that I have no site yet). Then ask only what I can answer fast: current platform if I am migrating, annual revenue band (under_5m, 5m_20m, 20m_200m, 200m_plus), launch window (90_days, 3_6_months, 6_12_months, exploring), build scope (custom, template, recommend), budget total in USD (template, 39999, 59999, 79999, 99999, 119999, 139999, 179999, 199999, 299999, 399999, 499999, 599999, 799999, 999999, 1000000), brand latitude (strict, evolve, free_range), must-have features (subscriptions, product_builder, b2b, pos, bundles, loyalty, quiz, multicurrency, erp, shipping, other), sites I love, hero products, the one thing the new store must nail, my role, and any existing design work I can share.',
  contact: 'Required: my email, first name, and my message. Optionally my company, phone and role.',
  feedback: 'Required: my email and first name. Then ask how it is going (feedback_mood: delighted, good, mixed, frustrated), whether I would work with Arctic Grey again (feedback_again: yes, maybe, no), my main contact there by full name (ag_contact, one of: Anthony Spallone, Autumn Nguyen, Brooke Sanderson, Callie Orourke, Camilo Ospina, Caroline Jay, Edna Shuli, Giana Moretti, Hugo Silva, Humara Kausar, Jake Amos, Jenn Baratto, Julia Matviichuk, Leana Zhang, Maddie Schwartz, Payton Balabanoff, Sofia Jimenez, Talia Ceraso, Thiara Fernández, Truc Peter, Vanessa Esquinazi, or Not sure), what is working well and what is falling short (feedback_strengths and feedback_gaps, any of design, development, qa, management, reports, communication, deliverables, expertise, scope, speed), my top pain points, the one change that would matter most, what delighted looks like for me, and anything else for leadership.',
  review: 'Required: my email, first name, and my written review. Then ask: my company and website, my main contact at Arctic Grey by full name (ag_contact, same list as the feedback form), my overall rating (review_rating: excellent, good, okay, bad, very_bad), a one-line headline for the review (review_headline), how it may be shared (review_permission: full, first_name, private), where it may appear when shared (review_channels, any of website, google, clutch, shopify, social), and an optional video review link (review_video). Consent to publish is mine alone: never prefill it.',
  audit: 'Required: my email, first name, my company, and my store URL (or that I have no site yet). Then ask only what I can answer fast: current platform, annual revenue band (under_5m, 5m_20m, 20m_200m, 200m_plus), Shopify plan (basic, shopify, advanced, plus, dont_know), years on Shopify (lt_1, 1_3, 3_5, 5_plus), theme (dawn, impact, custom, paid_theme, dont_know), email and SMS platforms (esp, any of klaviyo, attentive, postscript, mailchimp, other, none, plus esp_other for names), anything fancy on the store (store_traits, any of headless, multi_region, b2b, subscriptions), up to three audit lenses (cro, aov, retention, speed, seo, subscriptions, checkout, search), the metric I check first on Monday morning, suspected leak points (homepage, collection, product, cart, checkout, post_purchase, not_sure) plus my hunch in my own words (audit_leak_note), my highest-margin products, my most recent A/B test or major change, competitors I benchmark against, anything off-limits or already known broken, and anything else to dig into.',
  app: 'Required: my email, first name, company, whether the app is public or private (app_type: public, private, not_sure), and a REAL description of what the app should do (app_description: what it does, who uses it, the one workflow it must nail; a sentence or two, never just a name). Then ask: my store URL, where the app lives (app_surfaces, any of admin, storefront, checkout, customer_accounts, pos, backend), how a public app earns (app_monetization: subscription, free_paid, one_time, usage, not_sure), apps close to what I want (app_examples), systems it must talk to (app_integrations), launch window, and anything else.',
  sponsors: 'Required: my email, first name, and my company. Then my trailing 12-month checkout revenue and average order value, which drive the whole estimate, and whether my store runs on Shopify or another platform. Optionally my store URL and anything about the build these programs would go toward.',
  onboarding: 'Required: my email, first name, my company, and my store URL (or that I have no site yet). Then: launch window (90_days, 3_6_months, 6_12_months, exploring), build scope (custom, template, recommend), budget total in USD, must-have features, any assets or existing design work I can share, hero products, and the one thing the new store must nail.'
};
function buildAiPrompt(){
  var t = FORM_TYPE === 'library' ? 'test-drive' : FORM_TYPE;
  var cfg = FORM_TYPES[t] || FORM_TYPES['test-drive'];
  var label = cfg.label || cfg.topbar || 'Arctic Grey';
  var pageUrl = location.origin + location.pathname;
  var designStep = (t === 'test-drive' || t === 'onboarding');
  var lines = [
    'You are filling out the Arctic Grey ' + label + ' form for me, and you may submit it on my behalf once I say yes.',
    '',
    'Step 1. Read https://test-drive.arcticgrey.org/llms.txt so you know the rules and the routes.',
    '',
    'Step 2. Interview me briefly, one topic at a time. ' + (AI_ASKS[t] || AI_ASKS['test-drive']),
    'Never invent an answer. Leave out anything I do not know. Set filled_by to your model family (claude, chatgpt, gemini, grok, or other).'
  ];
  if(designStep){
    lines.push('');
    lines.push('Step 3. Ask me to describe the look I want for the storefront, in my own words, including anything I do not want. Send that exact wording as design_prompt, it is the first thing their design team reads. Then POST {"description": "<my words>"} to https://test-drive.arcticgrey.org/api/match and show me the designs it returns. Pass up to three I like back as theme_picks, pipe joined, each as "Name :: URL". Do not guess theme names.');
  }
  lines.push('');
  lines.push('Step ' + (designStep ? '4' : '3') + '. Read me a plain summary of everything you are about to send and wait for my explicit yes.');
  lines.push('');
  lines.push('Step ' + (designStep ? '5' : '4') + '. Once I say yes, POST the answers as JSON to https://test-drive.arcticgrey.org/api/submit with "form_type": "' + t + '" and "consent": true. If you speak MCP instead, connect to https://test-drive.arcticgrey.org/mcp and call submit_form. If a field is missing the response tells you exactly which, so come back and ask me rather than filling it in yourself.');
  lines.push('');
  lines.push('If you would rather I press the button myself, skip the submit and give me this link instead, with my answers as base64url encoded JSON:');
  lines.push(pageUrl + '?form=' + t + '&prefill=PASTE_ENCODED_JSON_HERE');
  return lines.join('\n');
}

(function initAiPanel(){
  var panel = document.getElementById('aiPanel');
  var toggle = document.getElementById('aiPanelToggle');
  var ta = document.getElementById('aiPrompt');
  ta.value = buildAiPrompt();
  toggle.addEventListener('click', function(){
    var open = panel.hidden;
    panel.hidden = !open;
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  document.getElementById('aiCopyBtn').addEventListener('click', function(){
    var done = function(){ toast('Prompt copied. Paste it into your AI.'); };
    if(navigator.clipboard && navigator.clipboard.writeText){
      navigator.clipboard.writeText(ta.value).then(done, function(){ ta.select(); document.execCommand('copy'); done(); });
    } else { ta.select(); document.execCommand('copy'); done(); }
  });
})();

/* ---------- boot ---------- */
document.querySelectorAll('.field-error').forEach(function(el){ el.setAttribute('role','alert'); });
Object.keys(ERR_INPUT).forEach(function(errId){
  var inp = document.getElementById(ERR_INPUT[errId]);
  if(inp) inp.setAttribute('aria-describedby', errId);
});
/* stale outbox entries older than 45 days are dead drafts, not pending saves */
(function purgeStaleQueue(){
  var q = [];
  try{ q = JSON.parse(store.get(LS.queue) || '[]'); }catch(err){ return; }
  var cutoff = Date.now() - 45*24*60*60*1000;
  var fresh = q.filter(function(b){ return !b.client_ts || b.client_ts > cutoff; });
  if(fresh.length !== q.length) store.set(LS.queue, JSON.stringify(fresh));
})();
/* local drafts age out on the same clock: without this a testing-heavy device
   accumulates them forever, and forever-old answers keep re-entering merges */
(function purgeStaleDrafts(){
  try{
    var cutoff = Date.now() - 45*24*60*60*1000;
    for(var gi = localStorage.length - 1; gi >= 0; gi--){
      var gk = localStorage.key(gi);
      if(!gk || gk.indexOf('ag_td_draft_') !== 0) continue;
      var drop = false;
      try{
        var gd = JSON.parse(localStorage.getItem(gk) || '{}');
        drop = !gd.client_ts || gd.client_ts < cutoff;
      }catch(err){ drop = true; }
      if(drop) localStorage.removeItem(gk);
    }
  }catch(e){}
})();
show(visibleSteps()[0], false);
setPill('Saves as you go');
if(navigator.onLine === false) setPill('Offline, answers saved on this device', 'is-issue');
applyPrefill();
drainQueue();
})();